import { useEffect, useRef, useState } from "react";
import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
  Stack,
  ButtonBase,
  Avatar,
  Switch,
  CardContent,
  Grid,
  Card,
  CardHeader,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ToggleButtonGroup,
  ToggleButton,
  Dialog,
  DialogContent,
  Alert,
  Checkbox,
  IconButton,
  SvgIcon,
  Tooltip,
  Container,
  Chip,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import ArrowRightIcon from "@untitled-ui/icons-react/build/esm/ArrowRight";
import {
  getFirestore,
  addDoc,
  collection,
  doc,
  query,
  where,
  updateDoc,
  getDoc,
  onSnapshot,
  getDocs,
  setDoc,
  limit,
  deleteDoc,
  deleteField,
  writeBatch,
} from "firebase/firestore";
import { Link } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { useParams } from "react-router-dom";
import { Scrollbar } from "../../components/scrollbar";
import DeleteIcon from "@mui/icons-material/Delete";
import SvgTela1 from "../../assets/tela1.svg";
import SvgTela2 from "../../assets/tela2.svg";
import SvgTela3 from "../../assets/tela3.svg";

import XIcon from "@untitled-ui/icons-react/build/esm/X";

import * as Yup from "yup";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import {
  LoadingButton,
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import format from "date-fns/format";
import { Image } from "@nextui-org/react";
import {
  initializeVotingArrays,
  canProceedToNextTurn,
  getCurrentVotingArray,
  addVoteToCorrectArray,
  removeVoteFromCorrectArray,
  ParlamentarVoto,
} from "../../utils/votingUtils";

type RoomParams = {
  id: string;
};

export function SessoesPlenarioInfo() {
  const rootRef = useRef(null);

  const [selected, setSelected] = useState(1);
  const [onSelect, setOnSelect] = useState(1);
  const [atas, setAtas] = useState([]);
  const [statusConfigSessao, setStatusConfigSessao] = useState(0);
  const [pautas, setPautas] = useState([]);
  const [parlamentares, setParlamentares] = useState([]);
  const [parlamentaresPequenoExp, setParlamentaresPequenoExp] = useState([]);
  const [parlamentaresGrandeExp, setParlamentaresGrandeExp] = useState([]);
  const [parlamentarSelectedGrandeExp, setParlamentarSelectedGrandeExp] =
    useState();
  const [parlamentarSelectedApartear, setParlamentarSelectedApartear] =
    useState<any>();
  const [isPlayingApartearGrandeExp, setIsPlayingApartearGrandeExp] =
    useState(false);

  const [codePopular, setCodePopular] = useState("");

  const [open, setOnOpen] = useState(false);

  // Estados para modal de adicionar voto
  const [openAddVoteModal, setOpenAddVoteModal] = useState(false);
  const [selectedPautaForVote, setSelectedPautaForVote] = useState<any>(null);
  const [selectedParlamentarForVote, setSelectedParlamentarForVote] =
    useState<any>(null);
  const [selectedVoteType, setSelectedVoteType] = useState<
    "sim" | "nao" | "abstencao" | null
  >(null);
  const [savingVote, setSavingVote] = useState(false);

  // Estados para votos da Ata (admin)
  const [openAtaVotesModal, setOpenAtaVotesModal] = useState(false);
  const [selectedAtaForVotes, setSelectedAtaForVotes] = useState<any>(null);
  const [ataVotes, setAtaVotes] = useState<any[]>([]);
  const [ataVotesMap, setAtaVotesMap] = useState<any>({});
  const [pautaVotesMap, setPautaVotesMap] = useState<any>({});
  const [selectedParlamentarForAtaVote, setSelectedParlamentarForAtaVote] =
    useState<any>(null);
  const [selectedAtaVoteType, setSelectedAtaVoteType] = useState<
    "sim" | "nao" | "abster" | null
  >(null);
  const [savingAtaVote, setSavingAtaVote] = useState(false);

  // Estados para modal de marcar presença
  const [openPresencaModal, setOpenPresencaModal] = useState(false);
  const [presencaParlamentares, setPresencaParlamentares] = useState<any[]>([]);
  const [selectedParlamentarForPresenca, setSelectedParlamentarForPresenca] =
    useState<any>(null);

  // Estados para modal de ações da pauta
  const [openPautaActionsModal, setOpenPautaActionsModal] = useState(false);
  const [selectedPautaForActions, setSelectedPautaForActions] =
    useState<any>(null);

  const params = useParams<RoomParams>();
  const roomId = params.id;

  const getTwoTurnStatus = (pauta: any) => {
    const votos1turno = Array.isArray(pauta?.votos1turno)
      ? pauta.votos1turno.length
      : 0;
    const votos2turno = Array.isArray(pauta?.votos2turno)
      ? pauta.votos2turno.length
      : 0;

    if (pauta?.statusAtual === "votacao1turno") return "votacao1turno";
    if (pauta?.statusAtual === "votacao2turno") return "votacao2turno";
    if (votos1turno > 0 && votos2turno === 0) return "pendente2turno";
    if (
      votos2turno > 0 ||
      pauta?.statusAtual === "votado" ||
      pauta?.statusAtual === "finalizada" ||
      pauta?.votada
    ) {
      return "finalizada";
    }

    return "aguardo";
  };

  useEffect(() => {
    const selectedId = selectedPautaForActions?.id;
    if (!selectedId) return;

    const pautaAtualizada = (pautas as any[]).find(
      (pauta: any) => pauta.id === selectedId
    );

    if (!pautaAtualizada) return;

    setSelectedPautaForActions((prev: any) => {
      if (!prev) return prev;

      const mudou =
        prev.votado !== pautaAtualizada.votado ||
        prev.iniciarVotacao !== pautaAtualizada.iniciarVotacao ||
        prev.encerrarVotacao !== pautaAtualizada.encerrarVotacao ||
        prev.statusAtual !== pautaAtualizada.statusAtual ||
        prev.votada !== pautaAtualizada.votada;

      return mudou ? { ...prev, ...pautaAtualizada } : prev;
    });
  }, [pautas, selectedPautaForActions?.id]);

  useEffect(() => {
    const db = getFirestore();
    const auth = getAuth();

    const collectionRef = collection(
      db,
      "users",
      "belacruz@eleg",
      "sessoes",
      `${roomId}`,
      "pautas"
    );

    onSnapshot(collectionRef, async (snapshot) => {
      //@ts-ignore
      const documentos = [];

      await Promise.all(
        snapshot.docs.map(async (docSnapshot) => {
          const documentoRef = doc(
            db,
            "users",
            "belacruz@eleg",
            "pautas",
            docSnapshot.data().idPauta
          );
          const consultaAdicionalSnapshot = await getDoc(documentoRef);

          //@ts-ignore
          function limitarCaracteres(texto, limite) {
            if (texto.length <= limite) {
              return texto;
            }
            return texto.slice(0, limite) + "...";
          }
          //@ts-ignore
          const textoPautaSemTags = consultaAdicionalSnapshot.data().expressoes
            ? //@ts-ignore
              consultaAdicionalSnapshot
                .data()
                .expressoes.replace(/<\/?[^>]+(>|$)/g, "")
                .replace(/\.&nbsp\./g, "")
                .replace(/&nbsp;/g, " ")
            : "";

          //@ts-ignore
          const textoLongo = textoPautaSemTags || ""; // Garante que `expressoes` esteja definido
          const textoLimitado = limitarCaracteres(textoLongo, 1000);

          documentos.push({
            ...consultaAdicionalSnapshot.data(),
            expressoes: textoLimitado,
            id: docSnapshot.id,
            idPauta: docSnapshot.data().idPauta,
            ...docSnapshot.data(),
          });
        })
      );

      //@ts-ignore
      setPautas(documentos);
    });

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "atas"
    );

    onSnapshot(
      ordersRef,
      (snapshot) => {
        //@ts-ignore
        const documentos = [];

        snapshot.forEach((doc) => {
          const data = doc.data();

          //@ts-ignore
          function limitarCaracteres(texto, limite) {
            if (texto.length <= limite) {
              return texto;
            }
            return texto.slice(0, limite) + "...";
          }

          const textoLongo = data.textoAta;
          const textoLimitado = limitarCaracteres(textoLongo, 300);

          const obj = {
            id: doc.id,
            tituloAtaExpediente: data.tituloAtaExpediente,
            textoAta: textoLimitado,
            leituraVis: data.leituraVis,
            solicitacaoVotacao: data.solicitacaoVotacao,
          };
          documentos.push(obj);
        });

        //@ts-ignore
        setAtas(documentos);
      },
      (error) => {
        console.error("Erro ao observar a coleção:", error);
      }
    );

    const ordersRefStatusConfig = doc(
      db,
      "users",
      "belacruz@eleg",
      "sessoes",
      `${roomId}`
    );

    onSnapshot(
      ordersRefStatusConfig,
      (snapshot) => {
        //@ts-ignore
        setStatusConfigSessao(snapshot.data().statusConfigSessao);
      },
      (error) => {
        console.error("Erro ao observar o documento:", error);
      }
    );

    const parlamentaresInfo = collection(
      db,
      "users",
      "belacruz@eleg",
      "sessoes",
      `${roomId}`,
      "pequeno-expediente"
    );

    onSnapshot(
      parlamentaresInfo,
      (snapshot) => {
        //@ts-ignore
        const documentos = [];

        snapshot.forEach((doc) => {
          const data = doc.data();
          const id = doc.id;

          documentos.push({ id, ...data });
        });

        //@ts-ignore
        function compararTimestamps(a, b) {
          return a.momento - b.momento;
        }

        //@ts-ignore
        setParlamentaresPequenoExp(documentos.sort(compararTimestamps));
      },
      (error) => {
        console.error("Erro ao observar a coleção:", error);
      }
    );

    const parlamentaresGrandeExpdInfo = collection(
      db,
      "users",
      "belacruz@eleg",
      "sessoes",
      `${roomId}`,
      "grande-expediente"
    );
    onSnapshot(
      parlamentaresGrandeExpdInfo,
      (snapshot) => {
        //@ts-ignore
        const documentos = [];

        snapshot.forEach((doc) => {
          const data = doc.data();
          const id = doc.id;

          documentos.push({ id, ...data });
        });

        //@ts-ignore
        function compararTimestamps(a, b) {
          return a.momento - b.momento;
        }

        //@ts-ignore
        setParlamentaresGrandeExp(documentos.sort(compararTimestamps));
      },
      (error) => {
        console.error("Erro ao observar a coleção:", error);
      }
    );

    const ordersRefParlamentar = collection(
      db,
      "users",
      "belacruz@eleg",
      "parlamentares"
    );
    const queryRefParlamentar = query(
      ordersRefParlamentar,
      where("legislatura", "==", "Legislatura (2025) - (2028)"),
      where("parlamentarEstado", "==", "ativo")
    );

    getDocs(queryRefParlamentar).then((querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        // Cria um objeto com as propriedades e seus respectivos valores
        const obj = {
          id: doc.id,
          ...data,
          // Adicione outras propriedades e seus valores aqui, se necessário
        };
        return obj;
      });

      //@ts-ignore
      setParlamentares(parsedData);
    });

    //@ts-ignore
    const ordersRefSelectedGrandeExp = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "grande-expediente"
    );
    const queryRefSelectedGrandeExp = query(
      ordersRefSelectedGrandeExp,
      where("solicitacao", "==", true),
      limit(1)
    );

    onSnapshot(
      queryRefSelectedGrandeExp,
      (querySnapshot) => {
        if (querySnapshot.docs.length !== 0) {
          const parsedData = querySnapshot.docs.map((doc) => {
            const data = doc.data();
            // Cria um objeto com as propriedades e seus respectivos valores
            const obj = {
              id: doc.id,
              ...data,
              // Adicione outras propriedades e seus valores aqui, se necessário
            };
            return obj;
          });

          //@ts-ignore
          setParlamentarSelectedGrandeExp(parsedData[0].id);
        }
      },
      (error) => {
        console.error("Erro ao observar a coleção:", error);
      }
    );

    //@ts-ignore
    const ordersRefSelectedApartear = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "grande-expediente",
      `${parlamentarSelectedGrandeExp}`,
      "apartear"
    );
    const queryRefSelectedApartear = query(
      ordersRefSelectedApartear,
      where("solicitacaoApartear", "==", true),
      limit(1)
    );

    onSnapshot(
      queryRefSelectedApartear,
      (querySnapshot) => {
        if (querySnapshot.docs.length !== 0) {
          const parsedData = querySnapshot.docs.map((doc) => {
            const data = doc.data();
            // Cria um objeto com as propriedades e seus respectivos valores
            const obj = {
              id: doc.id,
              ...data,
              // Adicione outras propriedades e seus valores aqui, se necessário
            };
            return obj;
          });

          //@ts-ignore
          setParlamentarSelectedApartear(parsedData[0].id);
        }
      },
      (error) => {
        console.error("Erro ao observar a coleção:", error);
      }
    );

    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let code = "";

    for (let i = 0; i < 28; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      code += characters.charAt(randomIndex);
    }

    setCodePopular(code);

    // Carregar lista de parlamentares com presença
    const presencaParlamentaresRef = collection(
      db,
      "users",
      "belacruz@eleg",
      "sessoes",
      `${roomId}`,
      "presencaParlamentares"
    );

    onSnapshot(presencaParlamentaresRef, (snapshot) => {
      const presencas: any[] = [];
      snapshot.forEach((docSnapshot) => {
        const data = docSnapshot.data();
        if (data.presenca === true) {
          presencas.push({
            id: docSnapshot.id,
            ...data,
          });
        }
      });
      setPresencaParlamentares(presencas);
    });
  }, []);

  // Carregar votos da Ata selecionada quando o modal estiver aberto
  useEffect(() => {
    if (!openAtaVotesModal || !selectedAtaForVotes || !roomId) {
      setAtaVotes([]);
      return;
    }

    const db = getFirestore();
    const votosRef = collection(
      db,
      "users",
      "belacruz@eleg",
      "sessoes",
      `${roomId}`,
      "atas",
      `${selectedAtaForVotes.id}`,
      "ataVotacao"
    );

    const unsubscribe = onSnapshot(votosRef, (snapshot) => {
      const votos: any[] = [];
      snapshot.forEach((docSnapshot) => {
        votos.push({
          id: docSnapshot.id,
          ...docSnapshot.data(),
        });
      });
      setAtaVotes(votos);
    });

    return () => unsubscribe();
  }, [openAtaVotesModal, selectedAtaForVotes, roomId]);

  // Map de votos por Ata para resumo em tempo real
  useEffect(() => {
    if (!roomId || !atas || atas.length === 0) {
      setAtaVotesMap({});
      return;
    }

    const db = getFirestore();
    const unsubscribes: any[] = [];

    (atas as any[]).forEach((ata: any) => {
      if (!ata.id) return;
      const votosRef = collection(
        db,
        "users",
        "belacruz@eleg",
        "sessoes",
        `${roomId}`,
        "atas",
        `${ata.id}`,
        "ataVotacao"
      );

      const unsubscribe = onSnapshot(votosRef, (snapshot) => {
        const votos: any[] = [];
        snapshot.forEach((docSnapshot) => {
          votos.push({
            id: docSnapshot.id,
            ...docSnapshot.data(),
          });
        });

        setAtaVotesMap((prev: any) => ({
          ...prev,
          [ata.id]: votos,
        }));
      });

      unsubscribes.push(unsubscribe);
    });

    return () => {
      unsubscribes.forEach((unsub) => unsub && unsub());
    };
  }, [atas, roomId]);

  // Map de votos por Pauta (Ordem do Dia) para resumo em tempo real
  useEffect(() => {
    if (!roomId || !pautas || pautas.length === 0) {
      setPautaVotesMap({});
      return;
    }

    const db = getFirestore();
    const unsubscribes: any[] = [];

    (pautas as any[]).forEach((pauta: any) => {
      if (!pauta.idPauta) return;

      const pautaRef = doc(
        db,
        "users",
        "belacruz@eleg",
        "pautas",
        pauta.idPauta
      );

      const unsubscribe = onSnapshot(pautaRef, (docSnapshot) => {
        if (!docSnapshot.exists()) return;
        const data = docSnapshot.data() as any;

        // Usa utilitário para pegar o array de votos correto
        const currentVotes = getCurrentVotingArray(data as any);

        setPautaVotesMap((prev: any) => ({
          ...prev,
          [pauta.idPauta]: {
            votes: currentVotes,
            raw: data,
          },
        }));
      });

      unsubscribes.push(unsubscribe);
    });

    return () => {
      unsubscribes.forEach((unsub) => unsub && unsub());
    };
  }, [pautas, roomId]);

  const formik = useFormik({
    initialValues: {
      nomePopular: "",
      profissao: "",
      submit: null,
    },
    validationSchema: Yup.object({
      nomePopular: Yup.string().max(255).required("O campo é obrigatório"),
      profissao: Yup.string().max(255).required("O campo é obrigatório"),
    }),
    onSubmit: async (values, helpers) => {
      try {
        const db = getFirestore();
        const colecaoPaiRef = collection(db, "users");
        const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
        const subcolecaoRef = collection(novoDocumentoRef, "sessoes");
        const novoDocumentocCdeSessaoRef = doc(subcolecaoRef, `${roomId}`);
        const subColecaoGrandeExpediente = collection(
          novoDocumentocCdeSessaoRef,
          "grande-expediente"
        );
        const novoDocumentoPopularRef = doc(
          subColecaoGrandeExpediente,
          codePopular
        );

        await setDoc(novoDocumentoPopularRef, {
          nome:
            values.nomePopular !== undefined ? values.nomePopular : undefined,
          profissao:
            values.profissao !== undefined ? values.profissao : undefined,
          momento: new Date(),
          solicitacao: false,
          status: false,
          tempo: 10,
        });

        setOnOpen(false);

        helpers.setStatus({ success: true });
        helpers.setSubmitting(false);
        toast.success("Customer updated");
      } catch (err) {
        console.error(err);
        toast.error("Something went wrong!");
        helpers.setStatus({ success: false });
        //@ts-ignore
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    },
  });

  const simplesOptions = [
    {
      label: "Projeto de resolução",
      value: "projetoResolucao",
    },
    {
      label: "Emenda",
      value: "emenda",
    },
    {
      label: "Indicação",
      value: "indicacao",
    },
    {
      label: "Projeto de Decreto Legislativo",
      value: "projetoDecretoLegislativo",
    },
    {
      label: "Projeto de emenda à Lei orgânica",
      value: "projetoEmendaLeiOrganica",
    },
    {
      label: "Projeto de Lei Ordinária",
      value: "projetoLeiOrdinaria",
    },
    {
      label: "Projeto de Lei do Poder Executivo",
      value: "projetoLeiPoderExecutivo",
    },
    {
      label: "Projeto de Lei do Poder Legislativo",
      value: "projetoLeiPoderLegislativo",
    },
    {
      label: "Projeto Substitutivo",
      value: "projetoSubstitutivo",
    },
    {
      label: "Requerimento",
      value: "requerimento",
    },
    {
      label: "Subemenda",
      value: "subemenda",
    },
    {
      label: "Veto",
      value: "veto",
    },
    {
      label: "Pareceres das Comições",
      value: "pareceresComicoes",
    },
    {
      label: "Parecer",
      value: "parecer",
    },
    {
      label: "Mensagem",
      value: "mensagem",
    },
  ];

  return (
    <Box
      component="main"
      ref={rootRef}
      sx={{
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Dialog fullWidth maxWidth="sm" open={open}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={3}
          sx={{
            px: 3,
            py: 2,
          }}
        >
          <Typography variant="h6">Adicionar Popular</Typography>
          <IconButton
            color="inherit"
            onClick={() => {
              setOnOpen(!open);
            }}
          >
            <SvgIcon>
              <XIcon />
            </SvgIcon>
          </IconButton>
        </Stack>

        <DialogContent>
          <form onSubmit={formik.handleSubmit}>
            <Stack spacing={2}>
              <Grid container justifyContent="space-between">
                <TextField
                  error={
                    !!(formik.touched.nomePopular && formik.errors.nomePopular)
                  }
                  fullWidth
                  helperText={
                    formik.touched.nomePopular && formik.errors.nomePopular
                  }
                  label="Nome do Popular"
                  name="nomePopular"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.nomePopular}
                />
              </Grid>

              <Grid container justifyContent="space-between">
                <TextField
                  error={
                    !!(formik.touched.profissao && formik.errors.profissao)
                  }
                  fullWidth
                  helperText={
                    formik.touched.profissao && formik.errors.profissao
                  }
                  label="Pofissão"
                  name="profissao"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.profissao}
                />
              </Grid>

              <Card>
                <div className="relative isolate overflow-hidden bg-gray-900 py-16 sm:py-24 lg:py-12">
                  <div className="flex items-center justify-center mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="w-screen mr-20">
                      <h5 className="text-1xl font-bold tracking-tight text-white sm:text-2xl">
                        Adicione as informações do popular
                      </h5>
                      <p className="mt-4 leading-6 text-gray-300">
                        Adicione populares em debates mais importantes! Informe
                        informações básicas para listar os populares no telão.
                      </p>
                    </div>
                  </div>
                  <div
                    className="absolute left-1/2 top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6"
                    aria-hidden="true"
                  >
                    <div
                      className="aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
                      style={{
                        clipPath:
                          "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
                      }}
                    />
                  </div>
                </div>
              </Card>
            </Stack>

            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              flexWrap="wrap"
              spacing={3}
              sx={{ pt: 3 }}
            >
              <Button
                disabled={
                  formik.values.nomePopular !== "" &&
                  formik.values.profissao !== ""
                    ? false
                    : true
                }
                type="submit"
                variant="contained"
              >
                Adicionar
              </Button>
              <Button
                color="inherit"
                onClick={() => {
                  setOnOpen(!open);
                }}
                disabled={formik.isSubmitting}
              >
                Cancelar
              </Button>
            </Stack>
          </form>
        </DialogContent>
      </Dialog>

      <Box
        sx={{
          borderRightColor: "divider",
          borderRightStyle: "solid",
          borderRightWidth: 1,
          flex: "0 0 300px",
        }}
      >
        <Box sx={{ p: 2, mt: 1.5 }}>
          <Typography variant="h5">Fluxo da Sessão</Typography>
        </Box>

        <Stack
          component="ul"
          divider={<Divider />}
          sx={{
            borderBottomColor: "divider",
            borderBottomStyle: "solid",
            borderBottomWidth: 1,
            listStyle: "none",
            m: 0,
            p: 0,
          }}
        >
          <Stack component="li">
            <ButtonBase
              onClick={() => {
                setOnSelect(1);
                setSelected(1);
              }}
              sx={{
                alignItems: "center",
                justifyContent: "flex-start",
                p: 2,
                textAlign: "left",
                width: "100%",
              }}
            >
              <Avatar
                sx={{
                  mr: 2,
                  backgroundColor: selected == 1 ? "#2970FF" : null,
                }}
              >
                <Typography
                  color={selected == 1 ? "#fff" : "text.secondary"}
                  variant="button"
                >
                  1
                </Typography>
              </Avatar>
              <div>
                <Typography>Abertura</Typography>
                <Typography color="text.secondary" variant="body2">
                  Abertura da sessão
                </Typography>
              </div>
            </ButtonBase>
            <ButtonBase
              onClick={() => {
                setOnSelect(2);
                setSelected(2);
              }}
              sx={{
                alignItems: "center",
                justifyContent: "flex-start",
                p: 2,
                textAlign: "left",
                width: "100%",
              }}
            >
              <Avatar
                sx={{
                  mr: 2,
                  backgroundColor: selected == 2 ? "#2970FF" : null,
                }}
              >
                <Typography
                  color={selected == 2 ? "#fff" : "text.secondary"}
                  variant="button"
                >
                  2
                </Typography>
              </Avatar>
              <div>
                <Typography>Solicitar Presença</Typography>
                <Typography color="text.secondary" variant="body2">
                  Presença dos Parlamentares
                </Typography>
              </div>
            </ButtonBase>
            <ButtonBase
              onClick={() => {
                setOnSelect(3);
                setSelected(3);
              }}
              sx={{
                alignItems: "center",
                justifyContent: "flex-start",
                p: 2,
                textAlign: "left",
                width: "100%",
              }}
            >
              <Avatar
                sx={{
                  mr: 2,
                  backgroundColor: selected == 3 ? "#2970FF" : null,
                }}
              >
                <Typography
                  color={selected == 3 ? "#fff" : "text.secondary"}
                  variant="button"
                >
                  3
                </Typography>
              </Avatar>
              <div>
                <Typography>Leitura da Ata da sessão anterior</Typography>
              </div>
            </ButtonBase>
            <ButtonBase
              onClick={() => {
                setOnSelect(4);
                setSelected(4);
              }}
              sx={{
                alignItems: "center",
                justifyContent: "flex-start",
                p: 2,
                textAlign: "left",
                width: "100%",
              }}
            >
              <Avatar
                sx={{
                  mr: 2,
                  backgroundColor: selected == 4 ? "#2970FF" : null,
                }}
              >
                <Typography
                  color={selected == 4 ? "#fff" : "text.secondary"}
                  variant="button"
                >
                  4
                </Typography>
              </Avatar>
              <div>
                <Typography>Votação da Ata da sessão anterior</Typography>
              </div>
            </ButtonBase>
            <ButtonBase
              onClick={() => {
                setOnSelect(5);
                setSelected(5);
              }}
              sx={{
                alignItems: "center",
                justifyContent: "flex-start",
                p: 2,
                textAlign: "left",
                width: "100%",
              }}
            >
              <Avatar
                sx={{
                  mr: 2,
                  backgroundColor: selected == 5 ? "#2970FF" : null,
                }}
              >
                <Typography
                  color={selected == 5 ? "#fff" : "text.secondary"}
                  variant="button"
                >
                  5
                </Typography>
              </Avatar>
              <div>
                <Typography>Grande expediente</Typography>
              </div>
            </ButtonBase>

            <ButtonBase
              onClick={() => {
                setOnSelect(6);
                setSelected(6);
              }}
              sx={{
                alignItems: "center",
                justifyContent: "flex-start",
                p: 2,
                textAlign: "left",
                width: "100%",
              }}
            >
              <Avatar
                sx={{
                  mr: 2,
                  backgroundColor: selected == 6 ? "#2970FF" : null,
                }}
              >
                <Typography
                  color={selected == 6 ? "#fff" : "text.secondary"}
                  variant="button"
                >
                  6
                </Typography>
              </Avatar>
              <div>
                <Typography>Leitura da Pauta</Typography>
              </div>
            </ButtonBase>

            <ButtonBase
              onClick={() => {
                setOnSelect(7);
                setSelected(7);
              }}
              sx={{
                alignItems: "center",
                justifyContent: "flex-start",
                p: 2,
                textAlign: "left",
                width: "100%",
              }}
            >
              <Avatar
                sx={{
                  mr: 2,
                  backgroundColor: selected == 7 ? "#2970FF" : null,
                }}
              >
                <Typography
                  color={selected == 7 ? "#fff" : "text.secondary"}
                  variant="button"
                >
                  7
                </Typography>
              </Avatar>
              <div>
                <Typography>Ordem do dia</Typography>
              </div>
            </ButtonBase>
          </Stack>
        </Stack>
      </Box>

      <Box
        sx={{
          flex: "1 1 auto",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {(onSelect == 1 && (
          <Stack
            spacing={3}
            sx={{
              p: 3,
            }}
          >
            <Grid
              alignItems="center"
              container
              sx={{
                background:
                  "linear-gradient(225deg, #111927 20%, #0E1F6D 100%)",
                borderRadius: 3,
                color: "common.white",
                maxHeight: 200,
                paddingLeft: 5,
                flexDirection: "row",
                overflow: "hidden",
              }}
            >
              <Grid
                xs={12}
                sm={8}
                sx={{
                  display: "-ms-grid",
                  maxHeight: 200,
                }}
              >
                <Typography color="inherit" variant="h5">
                  Para visualizar a 1ª tela da sessão.
                </Typography>
                <Typography color="inherit" sx={{ mt: 1 }} variant="body2">
                  Basta clicar no botão abaixo para visualizar.
                </Typography>
                <Link
                  to={`/sessao/tela/1/${roomId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    color="primary"
                    size="small"
                    sx={{ mt: 2, borderRadius: 0.75 }}
                    variant="contained"
                  >
                    Visualizar página
                  </Button>
                </Link>
              </Grid>
              <Grid
                xs={12}
                sm={4}
                sx={{
                  display: "flex",
                  maxHeight: 180,
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                }}
              >
                <img src={SvgTela1} width={200} height={200} />
              </Grid>
            </Grid>
          </Stack>
        )) ||
          (onSelect == 2 && (
            <Stack spacing={4}>
              <CardContent sx={{ pt: 3 }}>
                <Grid container justifyContent="space-between">
                  <Stack
                    alignItems="center"
                    direction="row"
                    justifyContent="space-between"
                    spacing={3}
                  >
                    <Stack spacing={1}>
                      <Typography gutterBottom variant="subtitle1">
                        Solicite a Presença
                      </Typography>
                      <Typography color="text.secondary" variant="body2">
                        Visa convocar a presença dos participantes no sistema
                        para uma sessão específica
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Tooltip title="Marcar presença manualmente">
                        <IconButton
                          onClick={() => setOpenPresencaModal(true)}
                          className="!bg-[#2970FF]/10 hover:!bg-[#2970FF]/20 !text-[#2970FF]"
                        >
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 4v16m8-8H4"
                            />
                          </svg>
                        </IconButton>
                      </Tooltip>
                      <Switch
                        color="primary"
                        edge="start"
                        name="isVerified"
                        onChange={async () => {
                          const db = getFirestore();
                          const auth = getAuth();
                          const colecaoPaiRef = collection(db, "users");

                          const novoDocumentoRef = doc(
                            colecaoPaiRef,
                            "belacruz@eleg"
                          );
                          const subcolecaoRef = collection(
                            novoDocumentoRef,
                            "sessoes"
                          );
                          const novoDocumento2Ref = doc(
                            subcolecaoRef,
                            `${roomId}`
                          );

                          getDoc(novoDocumento2Ref).then((docSnapshot) => {
                            if (docSnapshot.exists()) {
                              // Acessando os dados do documento
                              const documentData = docSnapshot.data();

                              // Atualize o campo específico nos dados do documento
                              const updatedData = {
                                ...documentData,
                                statusConfigSessao: 1,
                              };

                              // Atualize o documento usando o método `updateDoc`
                              return updateDoc(novoDocumento2Ref, updatedData);
                            } else {
                              throw new Error("O documento não existe!");
                            }
                          });
                        }}
                        checked={statusConfigSessao === 1 ? true : false}
                      />
                    </Stack>
                  </Stack>
                </Grid>
              </CardContent>

              {/* Lista de Vereadores que já marcaram presença */}
              {presencaParlamentares.length > 0 && (
                <CardContent sx={{ pt: 3 }}>
                  <div className="mb-4">
                    <Typography gutterBottom variant="subtitle1" sx={{ mb: 2 }}>
                      Vereadores Presentes ({presencaParlamentares.length})
                    </Typography>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      {presencaParlamentares.map((presenca: any) => {
                        // Buscar o parlamentar correspondente
                        const parlamentarEncontrado = (
                          parlamentares as any[]
                        ).find((p: any) => p.id === presenca.id);

                        // Obter o nome do vereador
                        const nomeVereador =
                          presenca.nome ||
                          (parlamentarEncontrado &&
                            parlamentarEncontrado.nome) ||
                          (parlamentarEncontrado &&
                            parlamentarEncontrado.parlamentarNome) ||
                          "Nome não informado";

                        return (
                          <div
                            key={presenca.id}
                            className="flex items-center gap-3 p-3 bg-green-50 rounded-lg border border-green-200 hover:bg-green-100 transition-colors"
                          >
                            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-500 flex items-center justify-center">
                              <svg
                                className="w-5 h-5 text-white"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-gray-900 truncate">
                                {nomeVereador}
                              </p>
                              <p className="text-xs text-green-600 font-medium">
                                Presente
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </CardContent>
              )}
            </Stack>
          )) ||
          (onSelect == 3 && (
            <Stack
              spacing={4}
              sx={{
                p: 2,
              }}
            >
              <Card>
                <CardHeader title="Atas do Expediente" />

                <Scrollbar>
                  <Table sx={{ minWidth: 600 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Título</TableCell>
                        <TableCell>Texto da Ata</TableCell>
                        <TableCell align="right">Exibir Ata</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {atas !== undefined &&
                        atas.map((item) => {
                          //@ts-ignore
                          function removeTags(textoHTML) {
                            const div = document.createElement("div");
                            div.innerHTML = textoHTML;
                            return div.textContent || div.innerText || "";
                          }

                          return (
                            <TableRow hover>
                              <TableCell>
                                <Typography variant="subtitle1">
                                  {/*@ts-ignore*/}
                                  {item.tituloAtaExpediente}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                {/*@ts-ignore*/}
                                {removeTags(item.textoAta)}
                              </TableCell>

                              <TableCell align="right">
                                <Switch
                                  color="primary"
                                  edge="start"
                                  name="isVerified"
                                  onChange={async () => {
                                    //@ts-ignore
                                    if (item.leituraVis == true) {
                                      const db = getFirestore();
                                      const auth = getAuth();
                                      const colecaoPaiRef = collection(
                                        db,
                                        "users"
                                      );

                                      const novoDocumentoRef = doc(
                                        colecaoPaiRef,
                                        "belacruz@eleg"
                                      );
                                      const subcolecaoRef = collection(
                                        novoDocumentoRef,
                                        "sessoes"
                                      );
                                      const novoDocumento2Ref = doc(
                                        subcolecaoRef,
                                        `${roomId}`
                                      );
                                      const subcolecaoRefAtas = collection(
                                        novoDocumento2Ref,
                                        "atas"
                                      );
                                      const novoDocumento2RefAtas = doc(
                                        subcolecaoRefAtas,
                                        //@ts-ignore
                                        `${item.id}`
                                      );

                                      getDoc(novoDocumento2RefAtas).then(
                                        (docSnapshot) => {
                                          if (docSnapshot.exists()) {
                                            // Acessando os dados do documento
                                            const documentData =
                                              docSnapshot.data();

                                            // Atualize o campo específico nos dados do documento
                                            const updatedData = {
                                              ...documentData,
                                              leituraVis: false,
                                            };

                                            // Atualize o documento usando o método `updateDoc`
                                            return updateDoc(
                                              novoDocumento2RefAtas,
                                              updatedData
                                            );
                                          } else {
                                            throw new Error(
                                              "O documento não existe!"
                                            );
                                          }
                                        }
                                      );
                                    } else {
                                      const db = getFirestore();
                                      const auth = getAuth();
                                      const colecaoPaiRefStatusConfig =
                                        collection(db, "users");

                                      const novoDocumentoRefStatusConfig = doc(
                                        colecaoPaiRefStatusConfig,
                                        "belacruz@eleg"
                                      );
                                      const subcolecaoRefStatusConfig =
                                        collection(
                                          novoDocumentoRefStatusConfig,
                                          "sessoes"
                                        );
                                      const novoDocumento2RefStatusConfig = doc(
                                        subcolecaoRefStatusConfig,
                                        `${roomId}`
                                      );

                                      getDoc(
                                        novoDocumento2RefStatusConfig
                                      ).then((docSnapshot) => {
                                        if (docSnapshot.exists()) {
                                          // Acessando os dados do documento
                                          const documentData =
                                            docSnapshot.data();

                                          // Atualize o campo específico nos dados do documento
                                          const updatedData = {
                                            ...documentData,
                                            statusConfigSessao: 2,
                                          };

                                          // Atualize o documento usando o método `updateDoc`
                                          return updateDoc(
                                            novoDocumento2Ref,
                                            updatedData
                                          );
                                        } else {
                                          throw new Error(
                                            "O documento não existe!"
                                          );
                                        }
                                      });

                                      const colecaoPaiRef = collection(
                                        db,
                                        "users"
                                      );

                                      const novoDocumentoRef = doc(
                                        colecaoPaiRef,
                                        "belacruz@eleg"
                                      );
                                      const subcolecaoRef = collection(
                                        novoDocumentoRef,
                                        "sessoes"
                                      );
                                      const novoDocumento2Ref = doc(
                                        subcolecaoRef,
                                        `${roomId}`
                                      );
                                      const subcolecaoRefAtas = collection(
                                        novoDocumento2Ref,
                                        "atas"
                                      );
                                      const novoDocumento2RefAtas = doc(
                                        subcolecaoRefAtas,
                                        //@ts-ignore
                                        `${item.id}`
                                      );

                                      getDoc(novoDocumento2RefAtas).then(
                                        (docSnapshot) => {
                                          if (docSnapshot.exists()) {
                                            // Acessando os dados do documento
                                            const documentData =
                                              docSnapshot.data();

                                            // Atualize o campo específico nos dados do documento
                                            const updatedData = {
                                              ...documentData,
                                              leituraVis: true,
                                            };

                                            // Atualize o documento usando o método `updateDoc`
                                            return updateDoc(
                                              novoDocumento2RefAtas,
                                              updatedData
                                            );
                                          } else {
                                            throw new Error(
                                              "O documento não existe!"
                                            );
                                          }
                                        }
                                      );
                                    }
                                  }}
                                  checked={
                                    //@ts-ignore
                                    item.leituraVis == true ? true : false
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </Scrollbar>
              </Card>
            </Stack>
          )) ||
          (onSelect == 4 && (
            <Stack
              spacing={4}
              sx={{
                p: 2,
              }}
            >
              <Card>
                <CardHeader title="Votação das Atas do Expediente" />

                <Scrollbar>
                  <Table sx={{ minWidth: 600 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Título</TableCell>
                        <TableCell>Texto da Ata</TableCell>
                        <TableCell align="right">Exibir votação</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {atas !== undefined &&
                        atas.map((item) => {
                          //@ts-ignore
                          function removeTags(textoHTML) {
                            const div = document.createElement("div");
                            div.innerHTML = textoHTML;
                            return div.textContent || div.innerText || "";
                          }

                          return (
                            <TableRow
                              hover
                              //@ts-ignore
                              key={item.id}
                            >
                              <TableCell>
                                <Typography variant="subtitle1">
                                  {/*@ts-ignore*/}
                                  {item.tituloAtaExpediente}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                {/*@ts-ignore*/}
                                {removeTags(item.textoAta)}

                                <Divider className="mt-2" />

                                {(() => {
                                  const votosAta =
                                    ataVotesMap[(item as any).id] || [];
                                  const totalPresentes =
                                    presencaParlamentares.length;
                                  const totalVotaram = votosAta.length;
                                  const faltam =
                                    totalPresentes - totalVotaram > 0
                                      ? totalPresentes - totalVotaram
                                      : 0;

                                  return (
                                    <div className="mt-3 flex flex-wrap items-center gap-3 text-xs">
                                      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-green-50 text-green-700 border border-green-200 font-medium">
                                        Votaram:{" "}
                                        <span className="font-semibold">
                                          {totalVotaram}
                                        </span>
                                      </span>
                                      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-yellow-50 text-yellow-700 border border-yellow-200 font-medium">
                                        Faltam votar:{" "}
                                        <span className="font-semibold">
                                          {faltam}
                                        </span>
                                      </span>
                                      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 border border-blue-200 font-medium">
                                        Presentes:{" "}
                                        <span className="font-semibold">
                                          {totalPresentes}
                                        </span>
                                      </span>
                                    </div>
                                  );
                                })()}

                                <Stack
                                  alignItems="center"
                                  justifyContent="center"
                                  direction="row"
                                  className="mt-4 w-full gap-4"
                                >
                                  <Button
                                    onClick={() => {
                                      const db = getFirestore();
                                      const auth = getAuth();
                                      const colecaoPaiRef = collection(
                                        db,
                                        "users"
                                      );

                                      const novoDocumentoRef = doc(
                                        colecaoPaiRef,
                                        "belacruz@eleg"
                                      );
                                      const subcolecaoRef = collection(
                                        novoDocumentoRef,
                                        "sessoes"
                                      );
                                      const novoDocumento2Ref = doc(
                                        subcolecaoRef,
                                        `${roomId}`
                                      );
                                      const subcolecaoRefAtas = collection(
                                        novoDocumento2Ref,
                                        "atas"
                                      );
                                      const novoDocumento2RefAtas = doc(
                                        subcolecaoRefAtas,
                                        //@ts-ignore
                                        `${item.id}`
                                      );

                                      getDoc(novoDocumento2RefAtas).then(
                                        (docSnapshot) => {
                                          if (docSnapshot.exists()) {
                                            // Acessando os dados do documento
                                            const documentData =
                                              docSnapshot.data();

                                            // Atualize o campo específico nos dados do documento
                                            const updatedData = {
                                              ...documentData,
                                              iniciarVotacao: true,
                                            };

                                            return updateDoc(
                                              novoDocumento2RefAtas,
                                              updatedData
                                            );
                                          } else {
                                            throw new Error(
                                              "O documento não existe!"
                                            );
                                          }
                                        }
                                      );
                                    }}
                                    color="primary"
                                    size="large"
                                    variant="outlined"
                                  >
                                    Iniciar votação
                                  </Button>

                                  <Button
                                    onClick={() => {
                                      const db = getFirestore();
                                      const auth = getAuth();
                                      const colecaoPaiRef = collection(
                                        db,
                                        "users"
                                      );

                                      const novoDocumentoRef = doc(
                                        colecaoPaiRef,
                                        "belacruz@eleg"
                                      );
                                      const subcolecaoRef = collection(
                                        novoDocumentoRef,
                                        "sessoes"
                                      );
                                      const novoDocumento2Ref = doc(
                                        subcolecaoRef,
                                        `${roomId}`
                                      );
                                      const subcolecaoRefAtas = collection(
                                        novoDocumento2Ref,
                                        "atas"
                                      );
                                      const novoDocumento2RefAtas = doc(
                                        subcolecaoRefAtas,
                                        //@ts-ignore
                                        `${item.id}`
                                      );

                                      getDoc(novoDocumento2RefAtas).then(
                                        (docSnapshot) => {
                                          if (docSnapshot.exists()) {
                                            // Acessando os dados do documento
                                            const documentData =
                                              docSnapshot.data();

                                            // Atualize o campo específico nos dados do documento
                                            const updatedData = {
                                              ...documentData,
                                              encerrarVotacao: true,
                                            };

                                            return updateDoc(
                                              novoDocumento2RefAtas,
                                              updatedData
                                            );
                                          } else {
                                            throw new Error(
                                              "O documento não existe!"
                                            );
                                          }
                                        }
                                      );
                                    }}
                                    color="primary"
                                    size="large"
                                    variant="outlined"
                                  >
                                    Encerrar votação
                                  </Button>

                                  <Button
                                    onClick={() => {
                                      setSelectedAtaForVotes(item);
                                      setSelectedParlamentarForAtaVote(null);
                                      setSelectedAtaVoteType(null);
                                      setOpenAtaVotesModal(true);
                                    }}
                                    color="primary"
                                    size="large"
                                    variant="contained"
                                  >
                                    Gerenciar votos
                                  </Button>
                                </Stack>
                              </TableCell>

                              <TableCell align="right">
                                <Switch
                                  color="primary"
                                  edge="start"
                                  name="isVerified"
                                  onChange={async () => {
                                    //@ts-ignore
                                    if (item.solicitacaoVotacao == true) {
                                      const db = getFirestore();
                                      const auth = getAuth();

                                      const colecaoPaiRefStatusConfig =
                                        collection(db, "users");

                                      const novoDocumentoRefStatusConfig = doc(
                                        colecaoPaiRefStatusConfig,
                                        "belacruz@eleg"
                                      );
                                      const subcolecaoRefStatusConfig =
                                        collection(
                                          novoDocumentoRefStatusConfig,
                                          "sessoes"
                                        );
                                      const novoDocumento2RefStatusConfig = doc(
                                        subcolecaoRefStatusConfig,
                                        `${roomId}`
                                      );

                                      getDoc(
                                        novoDocumento2RefStatusConfig
                                      ).then((docSnapshot) => {
                                        if (docSnapshot.exists()) {
                                          // Acessando os dados do documento
                                          const documentData =
                                            docSnapshot.data();

                                          // Atualize o campo específico nos dados do documento
                                          const updatedData = {
                                            ...documentData,
                                            statusConfigSessao: 3,
                                          };

                                          // Atualize o documento usando o método `updateDoc`
                                          return updateDoc(
                                            novoDocumento2Ref,
                                            updatedData
                                          );
                                        }
                                      });

                                      const colecaoPaiRef = collection(
                                        db,
                                        "users"
                                      );

                                      const novoDocumentoRef = doc(
                                        colecaoPaiRef,
                                        "belacruz@eleg"
                                      );
                                      const subcolecaoRef = collection(
                                        novoDocumentoRef,
                                        "sessoes"
                                      );
                                      const novoDocumento2Ref = doc(
                                        subcolecaoRef,
                                        `${roomId}`
                                      );
                                      const subcolecaoRefAtas = collection(
                                        novoDocumento2Ref,
                                        "atas"
                                      );
                                      const novoDocumento2RefAtas = doc(
                                        subcolecaoRefAtas,
                                        //@ts-ignore
                                        `${item.id}`
                                      );

                                      getDoc(novoDocumento2RefAtas).then(
                                        (docSnapshot) => {
                                          if (docSnapshot.exists()) {
                                            // Acessando os dados do documento
                                            const documentData =
                                              docSnapshot.data();

                                            // Atualize o campo específico nos dados do documento
                                            const updatedData = {
                                              ...documentData,
                                              solicitacaoVotacao: false,
                                            };

                                            // Atualize o documento usando o método `updateDoc`
                                            return updateDoc(
                                              novoDocumento2RefAtas,
                                              updatedData
                                            );
                                          } else {
                                            throw new Error(
                                              "O documento não existe!"
                                            );
                                          }
                                        }
                                      );
                                    } else {
                                      const db = getFirestore();
                                      const auth = getAuth();
                                      const colecaoPaiRef = collection(
                                        db,
                                        "users"
                                      );

                                      const novoDocumentoRef = doc(
                                        colecaoPaiRef,
                                        "belacruz@eleg"
                                      );
                                      const subcolecaoRef = collection(
                                        novoDocumentoRef,
                                        "sessoes"
                                      );
                                      const novoDocumento2Ref = doc(
                                        subcolecaoRef,
                                        `${roomId}`
                                      );
                                      const subcolecaoRefAtas = collection(
                                        novoDocumento2Ref,
                                        "atas"
                                      );
                                      const novoDocumento2RefAtas = doc(
                                        subcolecaoRefAtas,
                                        //@ts-ignore
                                        `${item.id}`
                                      );

                                      getDoc(novoDocumento2RefAtas).then(
                                        (docSnapshot) => {
                                          if (docSnapshot.exists()) {
                                            // Acessando os dados do documento
                                            const documentData =
                                              docSnapshot.data();

                                            // Atualize o campo específico nos dados do documento
                                            const updatedData = {
                                              ...documentData,
                                              solicitacaoVotacao: true,
                                            };

                                            // Atualize o documento usando o método `updateDoc`
                                            return updateDoc(
                                              novoDocumento2RefAtas,
                                              updatedData
                                            );
                                          } else {
                                            throw new Error(
                                              "O documento não existe!"
                                            );
                                          }
                                        }
                                      );

                                      const colecaoPaiRefStatusConfig =
                                        collection(db, "users");

                                      const novoDocumentoRefStatusConfig = doc(
                                        colecaoPaiRefStatusConfig,
                                        "belacruz@eleg"
                                      );
                                      const subcolecaoRefStatusConfig =
                                        collection(
                                          novoDocumentoRefStatusConfig,
                                          "sessoes"
                                        );
                                      const novoDocumento2RefStatusConfig = doc(
                                        subcolecaoRefStatusConfig,
                                        `${roomId}`
                                      );

                                      getDoc(
                                        novoDocumento2RefStatusConfig
                                      ).then((docSnapshot) => {
                                        if (docSnapshot.exists()) {
                                          // Acessando os dados do documento
                                          const documentData =
                                            docSnapshot.data();

                                          // Atualize o campo específico nos dados do documento
                                          const updatedData = {
                                            ...documentData,
                                            statusConfigSessao: 3,
                                          };

                                          // Atualize o documento usando o método `updateDoc`
                                          return updateDoc(
                                            novoDocumento2Ref,
                                            updatedData
                                          );
                                        }
                                      });
                                    }
                                  }}
                                  checked={
                                    //@ts-ignore
                                    item.solicitacaoVotacao == true
                                      ? true
                                      : false
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </Scrollbar>
              </Card>
            </Stack>
          )) ||
          (onSelect == 5 && (
            <Stack spacing={4}>
              <CardContent sx={{ pt: 3 }}>
                <Grid container justifyContent="space-between">
                  <Stack
                    alignItems="center"
                    direction="row"
                    justifyContent="space-between"
                    spacing={3}
                    sx={{
                      width: "100%",
                    }}
                  >
                    <Stack spacing={1}>
                      <Typography gutterBottom variant="subtitle1">
                        Exibir grande expediente
                      </Typography>
                      <Typography color="text.secondary" variant="body2">
                        Liste os vereadores inscritos no Grande expediente
                      </Typography>
                    </Stack>
                    <Switch
                      color="primary"
                      edge="start"
                      name="isVerified"
                      onChange={async () => {
                        const db = getFirestore();
                        const auth = getAuth();
                        const colecaoPaiRef = collection(db, "users");

                        const novoDocumentoRef = doc(
                          colecaoPaiRef,
                          "belacruz@eleg"
                        );
                        const subcolecaoRef = collection(
                          novoDocumentoRef,
                          "sessoes"
                        );
                        const novoDocumento2Ref = doc(
                          subcolecaoRef,
                          `${roomId}`
                        );

                        getDoc(novoDocumento2Ref).then((docSnapshot) => {
                          if (docSnapshot.exists()) {
                            // Acessando os dados do documento
                            const documentData = docSnapshot.data();

                            // Atualize o campo específico nos dados do documento
                            const updatedData = {
                              ...documentData,
                              statusConfigSessao: 4,
                            };

                            // Atualize o documento usando o método `updateDoc`
                            return updateDoc(novoDocumento2Ref, updatedData);
                          } else {
                            throw new Error("O documento não existe!");
                          }
                        });
                      }}
                      checked={statusConfigSessao === 4 ? true : false}
                    />
                  </Stack>
                </Grid>

                <Card sx={{ mt: 3 }}>
                  <CardHeader
                    title="Tempo de fala"
                    action={
                      <Button
                        color="primary"
                        variant="outlined"
                        onClick={() => {
                          setOnOpen(!open);
                        }}
                      >
                        Adicionar Popular
                      </Button>
                    }
                  />

                  <Scrollbar>
                    <Table sx={{ minWidth: 600 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Parlamentar</TableCell>
                          <TableCell align="center">Apartear</TableCell>
                          <TableCell align="center">Solicitação</TableCell>
                          <TableCell align="center">Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {parlamentaresGrandeExp !== undefined &&
                          parlamentaresGrandeExp
                            .sort((a, b) => {
                              // Ordem de prioridade
                              const prioridade = {
                                presidente: 1,
                                "vice-presidente": 2,
                                "1-secretário": 3,
                                "2-secretário": 4,
                                vereador: 5,
                              };

                              const prioridadeA =
                                //@ts-ignore
                                prioridade[a.funcaoPartidaria] || 999;
                              const prioridadeB =
                                //@ts-ignore
                                prioridade[b.funcaoPartidaria] || 999;

                              return prioridadeA - prioridadeB;
                            })
                            .map((item: any) => {
                              return (
                                <TableRow
                                  hover
                                  //@ts-ignore
                                  key={item.id}
                                >
                                  <TableCell>
                                    <div className="flex items-center gap-2">
                                      <Image
                                        src={item.imageP}
                                        alt="Foto do parlamentar"
                                        className="w-10 h-10 rounded-full object-cover"
                                      />

                                      <div>
                                        {item.email != undefined ? (
                                          <Typography variant="subtitle1">
                                            {item.nomeParlamentar}
                                          </Typography>
                                        ) : (
                                          <Typography variant="subtitle1">
                                            {item.nome}
                                          </Typography>
                                        )}
                                        {item.email != undefined ? (
                                          <Chip
                                            size="small"
                                            label={item.funcaoPartidaria}
                                          />
                                        ) : (
                                          <Chip
                                            size="small"
                                            color="success"
                                            label="Popular"
                                          />
                                        )}

                                        {item.email == undefined && (
                                          <Chip
                                            sx={{
                                              marginLeft: 2,
                                            }}
                                            size="small"
                                            label="Excluir"
                                            onClick={async () => {
                                              const db = getFirestore();
                                              await deleteDoc(
                                                doc(
                                                  db,
                                                  "users",
                                                  "mucambo@eleg",
                                                  "sessoes",
                                                  `${roomId}`,
                                                  "grande-expediente",
                                                  //@ts-ignore
                                                  `${item.id}`
                                                )
                                              );
                                            }}
                                            icon={<XIcon />}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </TableCell>

                                  <TableCell
                                    align="center"
                                    className="flex flex-col"
                                  >
                                    {isPlayingApartearGrandeExp == true ? (
                                      item.solicitacao != true ? (
                                        <div>
                                          {parlamentarSelectedApartear !=
                                            item.id && (
                                            <Button
                                              disabled={
                                                item.solicitacao == true
                                                  ? true
                                                  : false
                                              }
                                              color="warning"
                                              variant="outlined"
                                              onClick={async () => {
                                                const db = getFirestore();

                                                const colecaoPaiRef =
                                                  collection(db, "users");
                                                const novoDocumentoRef = doc(
                                                  colecaoPaiRef,
                                                  "belacruz@eleg"
                                                );
                                                const subcolecaoRef =
                                                  collection(
                                                    novoDocumentoRef,
                                                    "sessoes"
                                                  );
                                                const novoDocumentocCdeSessaoRef =
                                                  doc(
                                                    subcolecaoRef,
                                                    `${roomId}`
                                                  );
                                                const grandeExpedienteRef =
                                                  collection(
                                                    novoDocumentocCdeSessaoRef,
                                                    "grande-expediente"
                                                  );
                                                //@ts-ignore
                                                const parlamentarRef = doc(
                                                  grandeExpedienteRef,
                                                  parlamentarSelectedGrandeExp
                                                );
                                                const apartearRef = collection(
                                                  parlamentarRef,
                                                  "apartear"
                                                );

                                                const subcolecaosApartearDocRef =
                                                  doc(
                                                    apartearRef,
                                                    //@ts-ignore
                                                    `${item.id}`
                                                  );

                                                //@ts-ignore
                                                setParlamentarSelectedApartear(
                                                  `${item.id}`
                                                );

                                                await setDoc(
                                                  subcolecaosApartearDocRef,
                                                  {
                                                    //@ts-ignore
                                                    ...item,
                                                    momento: new Date(),
                                                    solicitacaoApartear: true,
                                                    statusApartear: true,
                                                    tempoApartear: 3,
                                                  }
                                                ).finally(() => {
                                                  const db = getFirestore();
                                                  const auth = getAuth();
                                                  const colecaoPaiRef =
                                                    collection(db, "users");

                                                  const novoDocumentoRef = doc(
                                                    colecaoPaiRef,
                                                    "belacruz@eleg"
                                                  );
                                                  const subcolecaoRef =
                                                    collection(
                                                      novoDocumentoRef,
                                                      "sessoes"
                                                    );
                                                  const novoDocumento2Ref = doc(
                                                    subcolecaoRef,
                                                    `${roomId}`
                                                  );
                                                  const subcolecaoRefAtas =
                                                    collection(
                                                      novoDocumento2Ref,
                                                      "grande-expediente"
                                                    );
                                                  //@ts-ignore
                                                  const novoDocumento2RefAtas =
                                                    doc(
                                                      subcolecaoRefAtas,
                                                      parlamentarSelectedGrandeExp
                                                    );

                                                  getDoc(
                                                    novoDocumento2RefAtas
                                                  ).then((docSnapshot) => {
                                                    if (docSnapshot.exists()) {
                                                      // Acessando os dados do documento
                                                      const documentData =
                                                        docSnapshot.data();

                                                      // Atualize o campo específico nos dados do documento
                                                      const updatedData = {
                                                        ...documentData,
                                                        status: false,
                                                      };

                                                      // Atualize o documento usando o método `updateDoc`
                                                      return updateDoc(
                                                        novoDocumento2RefAtas,
                                                        updatedData
                                                      );
                                                    } else {
                                                      throw new Error(
                                                        "O documento não existe!"
                                                      );
                                                    }
                                                  });
                                                });
                                              }}
                                            >
                                              Apartear
                                            </Button>
                                          )}

                                          {parlamentarSelectedApartear ==
                                            item.id && (
                                            <Button
                                              disabled={
                                                item.solicitacao == true
                                                  ? true
                                                  : false
                                              }
                                              color="inherit"
                                              onClick={() => {
                                                const db = getFirestore();
                                                const auth = getAuth();
                                                const colecaoPaiRef =
                                                  collection(db, "users");

                                                const novoDocumentoRef = doc(
                                                  colecaoPaiRef,
                                                  "belacruz@eleg"
                                                );
                                                const subcolecaoRef =
                                                  collection(
                                                    novoDocumentoRef,
                                                    "sessoes"
                                                  );
                                                const novoDocumento2Ref = doc(
                                                  subcolecaoRef,
                                                  `${roomId}`
                                                );
                                                const subcolecaoRefAtas =
                                                  collection(
                                                    novoDocumento2Ref,
                                                    "grande-expediente"
                                                  );
                                                //@ts-ignore
                                                const novoDocumento2RefAtas =
                                                  doc(
                                                    subcolecaoRefAtas,
                                                    `${parlamentarSelectedGrandeExp}`
                                                  );

                                                const apartearRef = collection(
                                                  novoDocumento2RefAtas,
                                                  "apartear"
                                                );

                                                const subcolecaosApartearDocRef =
                                                  doc(
                                                    apartearRef,
                                                    //@ts-ignore
                                                    `${item.id}`
                                                  );

                                                getDoc(
                                                  subcolecaosApartearDocRef
                                                ).then((docSnapshot) => {
                                                  if (docSnapshot.exists()) {
                                                    // Acessando os dados do documento
                                                    const documentData =
                                                      docSnapshot.data();

                                                    // Atualize o campo específico nos dados do documento
                                                    const updatedData = {
                                                      ...documentData,
                                                      statusApartear: false,
                                                      solicitacaoApartear:
                                                        false,
                                                    };

                                                    setParlamentarSelectedApartear(
                                                      ""
                                                    );

                                                    // Atualize o documento usando o método `updateDoc`
                                                    return updateDoc(
                                                      subcolecaosApartearDocRef,
                                                      updatedData
                                                    ).finally(() => {
                                                      const db = getFirestore();
                                                      const colecaoPaiRef =
                                                        collection(db, "users");

                                                      const novoDocumentoRef =
                                                        doc(
                                                          colecaoPaiRef,
                                                          "belacruz@eleg"
                                                        );
                                                      const subcolecaoRef =
                                                        collection(
                                                          novoDocumentoRef,
                                                          "sessoes"
                                                        );
                                                      const novoDocumento2Ref =
                                                        doc(
                                                          subcolecaoRef,
                                                          `${roomId}`
                                                        );
                                                      const subcolecaoRefAtas =
                                                        collection(
                                                          novoDocumento2Ref,
                                                          "grande-expediente"
                                                        );
                                                      //@ts-ignore
                                                      const novoDocumento2RefAtas =
                                                        doc(
                                                          subcolecaoRefAtas,
                                                          parlamentarSelectedGrandeExp
                                                        );

                                                      getDoc(
                                                        novoDocumento2RefAtas
                                                      ).then((docSnapshot) => {
                                                        if (
                                                          docSnapshot.exists()
                                                        ) {
                                                          // Acessando os dados do documento
                                                          const documentData =
                                                            docSnapshot.data();

                                                          // Atualize o campo específico nos dados do documento
                                                          const updatedData = {
                                                            ...documentData,
                                                            status: true,
                                                          };

                                                          // Atualize o documento usando o método `updateDoc`
                                                          return updateDoc(
                                                            novoDocumento2RefAtas,
                                                            updatedData
                                                          );
                                                        } else {
                                                          throw new Error(
                                                            "O documento não existe!"
                                                          );
                                                        }
                                                      });
                                                    });
                                                  } else {
                                                    throw new Error(
                                                      "O documento não existe!"
                                                    );
                                                  }
                                                });
                                              }}
                                            >
                                              Encerrar tempo
                                            </Button>
                                          )}
                                        </div>
                                      ) : (
                                        <div className="bg-[#F6F8FB] rounded-md">
                                          <p className="font-medium text-sm m-3 leading-6 py-2 tracking-tighter text-slate-800 mt-4">
                                            O vereador não pode apartear para
                                            ele mesmo
                                          </p>
                                        </div>
                                      )
                                    ) : (
                                      <div className="bg-[#F6F8FB] rounded-md">
                                        <p className="font-medium text-sm m-3 leading-6 py-2 tracking-tighter text-slate-800 mt-4">
                                          Nenhum vereador selecionado
                                        </p>
                                      </div>
                                    )}
                                  </TableCell>

                                  <TableCell align="center">
                                    <Button
                                      color={
                                        //@ts-ignore
                                        item.solicitacao != true
                                          ? "inherit"
                                          : "primary"
                                      }
                                      onClick={() => {
                                        const db = getFirestore();
                                        const auth = getAuth();
                                        const colecaoPaiRef = collection(
                                          db,
                                          "users"
                                        );

                                        const novoDocumentoRef = doc(
                                          colecaoPaiRef,
                                          "belacruz@eleg"
                                        );
                                        const subcolecaoRef = collection(
                                          novoDocumentoRef,
                                          "sessoes"
                                        );
                                        const novoDocumento2Ref = doc(
                                          subcolecaoRef,
                                          `${roomId}`
                                        );
                                        const subcolecaoRefAtas = collection(
                                          novoDocumento2Ref,
                                          "grande-expediente"
                                        );
                                        const novoDocumento2RefAtas = doc(
                                          subcolecaoRefAtas,
                                          //@ts-ignore
                                          `${item.id}`
                                        );

                                        getDoc(novoDocumento2RefAtas).then(
                                          (docSnapshot) => {
                                            if (docSnapshot.exists()) {
                                              // Acessando os dados do documento
                                              const documentData =
                                                docSnapshot.data();

                                              if (
                                                docSnapshot.data()
                                                  .solicitacao == true
                                              ) {
                                                // Atualize o campo específico nos dados do documento
                                                const updatedData = {
                                                  ...documentData,
                                                  solicitacao: false,
                                                };

                                                setIsPlayingApartearGrandeExp(
                                                  false
                                                );

                                                return updateDoc(
                                                  novoDocumento2RefAtas,
                                                  updatedData
                                                );
                                              } else {
                                                const updatedData = {
                                                  ...documentData,
                                                  solicitacao: true,
                                                };

                                                setIsPlayingApartearGrandeExp(
                                                  true
                                                );

                                                return updateDoc(
                                                  novoDocumento2RefAtas,
                                                  updatedData
                                                );
                                              }
                                            } else {
                                              throw new Error(
                                                "O documento não existe!"
                                              );
                                            }
                                          }
                                        );
                                      }}
                                    >
                                      {
                                        //@ts-ignore
                                        item.solicitacao != true
                                          ? "Exibir"
                                          : "Em telão"
                                      }
                                    </Button>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Button
                                      color={
                                        //@ts-ignore
                                        item.status != true
                                          ? "inherit"
                                          : "primary"
                                      }
                                      onClick={() => {
                                        //@ts-ignore
                                        if (item.status == true) {
                                          const db = getFirestore();
                                          const auth = getAuth();
                                          const colecaoPaiRef = collection(
                                            db,
                                            "users"
                                          );

                                          const novoDocumentoRef = doc(
                                            colecaoPaiRef,
                                            "belacruz@eleg"
                                          );
                                          const subcolecaoRef = collection(
                                            novoDocumentoRef,
                                            "sessoes"
                                          );
                                          const novoDocumento2Ref = doc(
                                            subcolecaoRef,
                                            `${roomId}`
                                          );
                                          const subcolecaoRefAtas = collection(
                                            novoDocumento2Ref,
                                            "grande-expediente"
                                          );
                                          const novoDocumento2RefAtas = doc(
                                            subcolecaoRefAtas,
                                            //@ts-ignore
                                            `${item.id}`
                                          );

                                          getDoc(novoDocumento2RefAtas).then(
                                            (docSnapshot) => {
                                              if (docSnapshot.exists()) {
                                                // Acessando os dados do documento
                                                const documentData =
                                                  docSnapshot.data();

                                                // Atualize o campo específico nos dados do documento
                                                const updatedData = {
                                                  ...documentData,
                                                  status: false,
                                                };

                                                // Atualize o documento usando o método `updateDoc`
                                                return updateDoc(
                                                  novoDocumento2RefAtas,
                                                  updatedData
                                                );
                                              } else {
                                                throw new Error(
                                                  "O documento não existe!"
                                                );
                                              }
                                            }
                                          );
                                        } else {
                                          const db = getFirestore();
                                          const auth = getAuth();
                                          const colecaoPaiRef = collection(
                                            db,
                                            "users"
                                          );

                                          const novoDocumentoRef = doc(
                                            colecaoPaiRef,
                                            "belacruz@eleg"
                                          );
                                          const subcolecaoRef = collection(
                                            novoDocumentoRef,
                                            "sessoes"
                                          );
                                          const novoDocumento2Ref = doc(
                                            subcolecaoRef,
                                            `${roomId}`
                                          );
                                          const subcolecaoRefAtas = collection(
                                            novoDocumento2Ref,
                                            "grande-expediente"
                                          );
                                          const novoDocumento2RefAtas = doc(
                                            subcolecaoRefAtas,
                                            //@ts-ignore
                                            `${item.id}`
                                          );

                                          getDoc(novoDocumento2RefAtas).then(
                                            (docSnapshot) => {
                                              if (docSnapshot.exists()) {
                                                // Acessando os dados do documento
                                                const documentData =
                                                  docSnapshot.data();

                                                // Atualize o campo específico nos dados do documento
                                                const updatedData = {
                                                  ...documentData,
                                                  status: true,
                                                };

                                                // Atualize o documento usando o método `updateDoc`
                                                return updateDoc(
                                                  novoDocumento2RefAtas,
                                                  updatedData
                                                );
                                              } else {
                                                throw new Error(
                                                  "O documento não existe!"
                                                );
                                              }
                                            }
                                          );
                                        }
                                      }}
                                    >
                                      {
                                        //@ts-ignore
                                        item.status != true
                                          ? "Iniciar"
                                          : "Pausar"
                                      }
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                      </TableBody>
                    </Table>
                  </Scrollbar>
                </Card>
              </CardContent>
            </Stack>
          )) ||
          (onSelect == 6 && (
            <Stack
              spacing={4}
              sx={{
                p: 2,
              }}
            >
              <Card>
                <CardHeader title="Pautas da Sessão" />

                <Scrollbar>
                  <Table sx={{ minWidth: 600 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Número</TableCell>
                        <TableCell>Autor</TableCell>
                        <TableCell>Tipo da pauta</TableCell>
                        <TableCell>Descrição</TableCell>
                        <TableCell align="right">Exibir Pauta</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {pautas !== undefined &&
                        pautas.map((item) => {
                          //@ts-ignore
                          function removeTags(textoHTML) {
                            const div = document.createElement("div");
                            div.innerHTML = textoHTML;
                            return div.textContent || div.innerText || "";
                          }

                          const labelCorrespondente = simplesOptions.find(
                            //@ts-ignore
                            (opcao) => opcao.value === item.pautaLegislativa
                          );

                          return (
                            <TableRow
                              //@ts-ignore
                              key={item.id}
                            >
                              <TableCell>
                                <Typography>
                                  {/*@ts-ignore*/}
                                  {item.numero}
                                </Typography>
                              </TableCell>

                              <TableCell>
                                <Typography>
                                  {/*@ts-ignore*/}
                                  {labelCorrespondente?.label}
                                </Typography>
                              </TableCell>

                              <TableCell>
                                <Typography>
                                  {/*@ts-ignore*/}
                                  {item.autor === undefined
                                    ? `Não informado`
                                    : //@ts-ignore
                                      item.autor}
                                </Typography>
                              </TableCell>

                              <TableCell>
                                <Typography>
                                  {/*@ts-ignore*/}
                                  {removeTags(item.expressoes)}
                                </Typography>
                              </TableCell>

                              <TableCell align="right">
                                <Switch
                                  color="primary"
                                  edge="start"
                                  name="isVerified"
                                  onChange={async () => {
                                    const db = getFirestore();
                                    const colecaoPaiRef = collection(
                                      db,
                                      "users"
                                    );

                                    const novoDocumentoRef = doc(
                                      colecaoPaiRef,
                                      "belacruz@eleg"
                                    );
                                    const subcolecaoRef = collection(
                                      novoDocumentoRef,
                                      "sessoes"
                                    );
                                    const novoDocumento2Ref = doc(
                                      subcolecaoRef,
                                      `${roomId}`
                                    );

                                    getDoc(novoDocumento2Ref).then(
                                      (docSnapshot) => {
                                        if (docSnapshot.exists()) {
                                          // Acessando os dados do documento
                                          const documentData =
                                            docSnapshot.data();

                                          // Atualize o campo específico nos dados do documento
                                          const updatedData = {
                                            ...documentData,
                                            statusConfigSessao: 5,
                                          };

                                          // Atualize o documento usando o método `updateDoc`
                                          return updateDoc(
                                            novoDocumento2Ref,
                                            updatedData
                                          );
                                        } else {
                                          throw new Error(
                                            "O documento não existe!"
                                          );
                                        }
                                      }
                                    );
                                    const docPautaRef = doc(
                                      db,
                                      "users",
                                      "belacruz@eleg",
                                      "sessoes",
                                      `${roomId}`,
                                      "pautas",
                                      //@ts-ignore
                                      `${item.id}`
                                    );
                                    getDoc(docPautaRef)
                                      .then((docSnapshot) => {
                                        if (docSnapshot.exists()) {
                                          // Acessando os dados do documento
                                          const documentData =
                                            docSnapshot.data();

                                          // Atualize o campo específico nos dados do documento
                                          if (documentData.leituraVis == true) {
                                            const updatedData = {
                                              ...documentData,
                                              leituraVis: false,
                                            };
                                            // Atualize o documento usando o método `updateDoc`
                                            return updateDoc(
                                              docPautaRef,
                                              updatedData
                                            );
                                          } else {
                                            const updatedData = {
                                              ...documentData,
                                              leituraVis: true,
                                            };

                                            // Atualize o documento usando o método `updateDoc`
                                            return updateDoc(
                                              docPautaRef,
                                              updatedData
                                            );
                                          }
                                        } else {
                                          throw new Error(
                                            "O documento não existe!"
                                          );
                                        }
                                      })
                                      .catch((error) => {
                                        console.error(
                                          "Erro ao obter o documento:",
                                          error
                                        );
                                      });
                                    const documentoRef = doc(
                                      db,
                                      "users",
                                      "belacruz@eleg",
                                      "pautas",
                                      //@ts-ignore
                                      `${item.idPauta}`
                                    );

                                    getDoc(documentoRef)
                                      .then((docSnapshot) => {
                                        if (docSnapshot.exists()) {
                                          // Acessando os dados do documento
                                          const documentData =
                                            docSnapshot.data();

                                          // Atualize o campo específico nos dados do documento
                                          const updatedData = {
                                            ...documentData,
                                            statusAtual: "leitura",
                                          };

                                          // Atualize o documento usando o método `updateDoc`
                                          return updateDoc(
                                            documentoRef,
                                            updatedData
                                          );
                                        } else {
                                          throw new Error(
                                            "O documento não existe!"
                                          );
                                        }
                                      })
                                      .catch((error) => {
                                        console.error(
                                          "Erro ao obter o documento:",
                                          error
                                        );
                                      });
                                  }}
                                  checked={
                                    //@ts-ignore
                                    item.leituraVis == true ? true : false
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </Scrollbar>
              </Card>
            </Stack>
          )) ||
          (onSelect == 7 && (
            <Box
              sx={{
                // backgroundColor: 'neutral.100',
                p: 3,
              }}
            >
              <div className="align-start pt-2 pl-6 max-w-2xl">
                <h2 className="text-balance text-1xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
                  Ordem do dia
                </h2>
                <div className="flex mt-2 gap-x-4 sm:col-span-2">
                  <div className="flex h-6 items-center">
                    <button
                      type="button"
                      className={`flex w-8 flex-none cursor-pointer rounded-full p-px ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
                        statusConfigSessao === 6
                          ? "bg-[#2970FF]"
                          : "bg-gray-200"
                      }`}
                      role="switch"
                      aria-checked={statusConfigSessao === 6 ? true : false}
                      aria-labelledby="switch-1-label"
                      onClick={() => {
                        const db = getFirestore();
                        const auth = getAuth();
                        const colecaoPaiRef = collection(db, "users");

                        const novoDocumentoRef = doc(
                          colecaoPaiRef,
                          "belacruz@eleg"
                        );
                        const subcolecaoRef = collection(
                          novoDocumentoRef,
                          "sessoes"
                        );
                        const novoDocumento2Ref = doc(
                          subcolecaoRef,
                          `${roomId}`
                        );

                        getDoc(novoDocumento2Ref).then((docSnapshot) => {
                          if (docSnapshot.exists()) {
                            // Acessando os dados do documento
                            const documentData = docSnapshot.data();

                            // Atualize o campo específico nos dados do documento
                            const updatedData = {
                              ...documentData,
                              statusConfigSessao: 6,
                            };

                            // Atualize o documento usando o método `updateDoc`
                            return updateDoc(novoDocumento2Ref, updatedData);
                          } else {
                            throw new Error("O documento não existe!");
                          }
                        });
                      }}
                    >
                      <span className="sr-only">Agree to policies</span>
                      <span
                        aria-hidden="true"
                        className={`h-4 w-4 transform rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition duration-200 ease-in-out ${
                          statusConfigSessao === 6
                            ? "translate-x-3.5"
                            : "translate-x-0"
                        }`}
                      ></span>
                    </button>
                  </div>
                  <label
                    className="text-sm leading-6 text-gray-600"
                    id="switch-1-label"
                  >
                    Adicione o fluxo para a{" "}
                    <label className="font-semibold text-[#2970FF]">
                      votação da pautas
                    </label>
                    .
                  </label>
                </div>
              </div>
              <div className="w-full flex justify-center mt-4">
                <div className="w-full grid grid-cols-2 gap-4">
                  {pautas !== undefined &&
                    pautas.map((item) => {
                      const labelCorrespondente = simplesOptions.find(
                        //@ts-ignore
                        (opcao) => opcao.value === item.pautaLegislativa
                      );
                      const twoTurnStatus = getTwoTurnStatus(item);

                      return (
                        <Container maxWidth="xs" sx={{ mb: 2 }}>
                          <Card
                            className="overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                            onClick={() => {
                              setSelectedPautaForActions(item);
                              setOpenPautaActionsModal(true);
                            }}
                          >
                            {/* Header moderno */}
                            <div className="bg-gradient-to-r from-[#2970FF] to-[#2970FF]/90 px-6 py-4">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                  <div className="w-12 h-12 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
                                    <span className="text-2xl font-bold text-white">
                                      {/*@ts-ignore*/}
                                      {item.numero}
                                    </span>
                                  </div>
                                  <div>
                                    <p className="text-xs font-medium text-white/80 uppercase tracking-wider">
                                      Pauta
                                    </p>
                                    <p className="text-sm font-semibold text-white mt-0.5">
                                      {/*@ts-ignore*/}
                                      {labelCorrespondente?.label ||
                                        "Pauta Legislativa"}
                                    </p>
                                  </div>
                                </div>
                                {/*@ts-ignore*/}
                                {item.opcoesVotacao === "2-turnos" && (
                                  <div className="flex items-center gap-2">
                                    {twoTurnStatus === "votacao1turno" && (
                                      <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-orange-100 text-orange-700 border border-orange-200">
                                        1º Turno
                                      </span>
                                    )}
                                    {twoTurnStatus === "votacao2turno" && (
                                      <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200">
                                        2º Turno
                                      </span>
                                    )}
                                    {twoTurnStatus === "pendente2turno" && (
                                      <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-violet-100 text-violet-700 border border-violet-200">
                                        2º turno pendente
                                      </span>
                                    )}
                                    {twoTurnStatus === "finalizada" && (
                                      <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
                                        Finalizada
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>

                            <CardContent className="p-6">
                              {/* Informações principais */}
                              <div className="space-y-4 mb-6">
                                <div className="bg-gray-50 rounded-lg p-4 border border-gray-100">
                                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                                    Autor
                                  </p>
                                  <p className="text-sm font-medium text-gray-900">
                                    {/* @ts-ignore */}
                                    {item.autor || "Não informado"}
                                  </p>
                                </div>

                                <div className="bg-blue-50/50 rounded-lg p-4 border border-blue-100">
                                  <p className="text-xs font-semibold text-[#2970FF] uppercase tracking-wider mb-2">
                                    Expressões
                                  </p>
                                  <p className="text-sm text-gray-700 leading-relaxed line-clamp-4">
                                    {/* @ts-ignore */}
                                    {item.expressoes || "Sem descrição"}
                                  </p>
                                </div>
                              </div>

                              <div className="border-t border-gray-200 pt-4">
                                <div className="flex items-center gap-2 mb-4">
                                  <div className="h-1 w-1 rounded-full bg-[#2970FF]"></div>
                                  <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-600">
                                    Tramitações da pauta
                                  </h3>
                                </div>

                                <div className="relative">
                                  <div className="absolute left-3 top-0 bottom-0 w-0.5 bg-gray-200"></div>
                                  <div className="space-y-4 pl-8">
                                    {
                                      //@ts-ignore
                                      item.tramitacoes.map(
                                        (tramitacao: any, index: number) => {
                                          const isCompleted =
                                            tramitacao.data != undefined;
                                          return (
                                            <div
                                              key={index}
                                              className="relative"
                                            >
                                              <div className="absolute -left-11 top-1">
                                                <div
                                                  className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                                                    isCompleted
                                                      ? "bg-green-500 border-green-500"
                                                      : "bg-amber-400 border-amber-400"
                                                  }`}
                                                >
                                                  {isCompleted && (
                                                    <svg
                                                      className="w-3 h-3 text-white"
                                                      fill="currentColor"
                                                      viewBox="0 0 20 20"
                                                    >
                                                      <path
                                                        fillRule="evenodd"
                                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                        clipRule="evenodd"
                                                      />
                                                    </svg>
                                                  )}
                                                </div>
                                              </div>
                                              <div className="bg-white rounded-lg border border-gray-200 p-3 hover:border-gray-300 transition-colors">
                                                <p className="text-sm font-medium text-gray-900">
                                                  {tramitacao.status}
                                                </p>
                                                <p className="text-xs text-gray-500 mt-1">
                                                  {tramitacao.data != undefined
                                                    ? format(
                                                        new Date(
                                                          tramitacao.data
                                                        ),
                                                        "dd/MM/yyyy"
                                                      )
                                                    : tramitacao.tipo}
                                                </p>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    }
                                  </div>
                                </div>
                              </div>

                              {
                                //@ts-ignore
                                item.votado == true && (
                                  <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-[#2970FF]/5 via-blue-50/50 to-[#2970FF]/5 border border-[#2970FF]/20 mb-6 p-5">
                                    <div className="absolute top-0 right-0 w-32 h-32 bg-[#2970FF]/5 rounded-full -mr-16 -mt-16"></div>
                                    <div className="relative">
                                      <div className="flex items-start justify-between mb-3">
                                        <div className="flex items-center gap-3">
                                          <div className="w-10 h-10 rounded-lg bg-[#2970FF] flex items-center justify-center shadow-lg">
                                            <svg
                                              className="w-5 h-5 text-white"
                                              fill="none"
                                              stroke="currentColor"
                                              viewBox="0 0 24 24"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                              />
                                            </svg>
                                          </div>
                                          <div>
                                            <h2 className="text-base font-bold text-[#2970FF]">
                                              Pauta em exibição
                                            </h2>
                                            <p className="text-xs text-gray-600 mt-0.5">
                                              Exibindo nos tablets e telão
                                            </p>
                                          </div>
                                        </div>
                                        {/*@ts-ignore*/}
                                        {item.opcoesVotacao === "2-turnos" && (
                                          <div className="flex items-center gap-2">
                                            {twoTurnStatus ===
                                              "votacao1turno" && (
                                              <span className="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-semibold bg-orange-100 text-orange-700 border border-orange-200 shadow-sm">
                                                1º Turno
                                              </span>
                                            )}
                                            {twoTurnStatus ===
                                              "votacao2turno" && (
                                              <span className="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-200 shadow-sm">
                                                2º Turno
                                              </span>
                                            )}
                                            {twoTurnStatus ===
                                              "pendente2turno" && (
                                              <span className="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-semibold bg-violet-100 text-violet-700 border border-violet-200 shadow-sm">
                                                2º turno pendente
                                              </span>
                                            )}
                                            {twoTurnStatus === "finalizada" && (
                                              <span className="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-semibold bg-green-100 text-green-700 border border-green-200 shadow-sm">
                                                Finalizada
                                              </span>
                                            )}
                                          </div>
                                        )}
                                      </div>

                                      {/*@ts-ignore*/}
                                      {item.opcoesVotacao === "2-turnos" && (
                                        <div className="mt-3 pt-3 border-t border-[#2970FF]/10">
                                          <p className="text-sm text-gray-700 font-medium">
                                            {twoTurnStatus ===
                                              "votacao1turno" &&
                                              "Primeiro turno de votação em andamento"}
                                            {twoTurnStatus ===
                                              "votacao2turno" &&
                                              "Segundo turno de votação em andamento"}
                                            {twoTurnStatus ===
                                              "pendente2turno" &&
                                              "Primeiro turno concluído. Pauta pronta para o 2º turno"}
                                            {twoTurnStatus === "finalizada" &&
                                              "Votação finalizada com sucesso"}
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )
                              }

                              <Divider />

                              {/* Resumo de votos - apenas contadores */}
                              {(() => {
                                // Obter os votos atuais da pauta (preferindo map em tempo real)
                                const currentVotes =
                                  pautaVotesMap[(item as any).idPauta]?.votes ||
                                  getCurrentVotingArray(item as any);

                                // Mostrar resumo se houver votos ou se a pauta estiver em votação
                                const shouldShowVotes =
                                  currentVotes.length > 0 ||
                                  (item as any).votado == true ||
                                  (item as any).statusAtual ===
                                    "votacao1turno" ||
                                  (item as any).statusAtual === "votacao2turno";

                                if (!shouldShowVotes) return null;

                                // Criar um mapa dos votos por ID do parlamentar
                                const votosMap = new Map();
                                currentVotes.forEach((voto: any) => {
                                  votosMap.set(voto.parlamentar, voto);
                                });

                                // Contar vereadores que votaram e que não votaram
                                const vereadoresVotaram = parlamentares.filter(
                                  (parlamentar: any) =>
                                    votosMap.has(parlamentar.id)
                                );
                                const vereadoresNaoVotaram =
                                  parlamentares.filter(
                                    (parlamentar: any) =>
                                      !votosMap.has(parlamentar.id)
                                  );

                                return (
                                  <div className="mt-4 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
                                    <div className="flex items-center justify-between">
                                      <div className="flex items-center gap-4">
                                        <div className="flex items-center gap-2">
                                          <div className="w-2 h-2 rounded-full bg-green-500"></div>
                                          <span className="text-xs font-medium text-gray-700">
                                            Votaram:{" "}
                                            <span className="font-semibold text-green-600">
                                              {vereadoresVotaram.length}
                                            </span>
                                          </span>
                                        </div>
                                        {vereadoresNaoVotaram.length > 0 && (
                                          <div className="flex items-center gap-2">
                                            <div className="w-2 h-2 rounded-full bg-gray-400"></div>
                                            <span className="text-xs font-medium text-gray-700">
                                              Faltam:{" "}
                                              <span className="font-semibold text-gray-600">
                                                {vereadoresNaoVotaram.length}
                                              </span>
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                      <span className="text-xs text-[#2970FF] font-medium">
                                        Ver detalhes no modal
                                      </span>
                                    </div>
                                  </div>
                                );
                              })()}

                              <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                                <div className="flex items-center gap-2">
                                  <svg
                                    className="w-5 h-5 text-[#2970FF]"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                    />
                                  </svg>
                                  <span className="text-sm font-medium text-[#2970FF]">
                                    Clique no card para ver ações da pauta
                                  </span>
                                </div>
                              </div>

                              {/* Botões movidos para o modal de ações */}
                            </CardContent>
                          </Card>
                        </Container>
                      );
                    })}
                </div>
              </div>
            </Box>
          ))}
      </Box>

      {/* Modal para adicionar voto manualmente */}
      <Dialog
        open={openAddVoteModal}
        onClose={() => {
          if (!savingVote) {
            setOpenAddVoteModal(false);
            setSelectedPautaForVote(null);
            setSelectedParlamentarForVote(null);
            setSelectedVoteType(null);
            setSavingVote(false);
          }
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogContent className="!p-0">
          <div className="bg-gradient-to-r from-[#2970FF] to-[#2970FF]/90 px-6 py-4">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-bold text-white">
                Adicionar Voto Manualmente
              </h2>
              <IconButton
                onClick={() => {
                  if (!savingVote) {
                    setOpenAddVoteModal(false);
                    setSelectedPautaForVote(null);
                    setSelectedParlamentarForVote(null);
                    setSelectedVoteType(null);
                    setSavingVote(false);
                  }
                }}
                disabled={savingVote}
                className="!text-white hover:!bg-white/20"
              >
                <XIcon />
              </IconButton>
            </div>
            {selectedPautaForVote && (
              <p className="text-sm text-white/80 mt-2">
                Pauta: {selectedPautaForVote.numero || "N/A"}
              </p>
            )}
          </div>

          <div className="p-6 space-y-6 max-h-[70vh] overflow-y-auto">
            {/* Seleção de Vereador */}
            {(() => {
              // Obter os votos atuais da pauta (preferindo map em tempo real)
              const currentVotes = selectedPautaForVote
                ? pautaVotesMap[selectedPautaForVote.idPauta]?.votes ||
                  getCurrentVotingArray(selectedPautaForVote as any)
                : [];

              // Criar um Set com os IDs dos vereadores que já votaram
              const vereadoresQueVotaram = new Set(
                currentVotes.map((voto: any) => voto.parlamentar)
              );

              // Filtrar apenas vereadores que ainda não votaram
              const vereadoresNaoVotaram = parlamentares.filter(
                (parlamentar: any) => !vereadoresQueVotaram.has(parlamentar.id)
              );

              return (
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <label className="block text-sm font-semibold text-gray-700">
                      Selecione o Vereador
                    </label>
                    <span className="text-xs text-gray-500">
                      {vereadoresNaoVotaram.length} vereador(es) disponível(is)
                    </span>
                  </div>
                  {vereadoresNaoVotaram.length === 0 ? (
                    <div className="border border-gray-200 rounded-lg p-8 text-center bg-gray-50">
                      <svg
                        className="mx-auto h-12 w-12 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                        />
                      </svg>
                      <p className="mt-2 text-sm font-medium text-gray-900">
                        Todos os vereadores já votaram
                      </p>
                      <p className="mt-1 text-xs text-gray-500">
                        Não há vereadores disponíveis para adicionar voto
                        manualmente.
                      </p>
                    </div>
                  ) : (
                    <div className="border border-gray-200 rounded-lg divide-y divide-gray-200 max-h-60 overflow-y-auto">
                      {vereadoresNaoVotaram.map((parlamentar: any) => {
                        const isSelected =
                          selectedParlamentarForVote?.id === parlamentar.id;
                        return (
                          <button
                            key={parlamentar.id}
                            onClick={() =>
                              setSelectedParlamentarForVote(parlamentar)
                            }
                            className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors ${
                              isSelected
                                ? "bg-[#2970FF]/5 border-l-4 border-[#2970FF]"
                                : ""
                            }`}
                          >
                            <div className="flex items-center justify-between">
                              <span className="text-sm font-medium text-gray-900">
                                {parlamentar.nome ||
                                  parlamentar.parlamentarNome ||
                                  "Nome não informado"}
                              </span>
                              {isSelected && (
                                <svg
                                  className="w-5 h-5 text-[#2970FF]"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              )}
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })()}

            {/* Seleção de Tipo de Voto */}
            {selectedParlamentarForVote && (
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Selecione o Voto
                </label>
                <div className="grid grid-cols-3 gap-3">
                  <button
                    onClick={() => setSelectedVoteType("sim")}
                    className={`p-4 rounded-lg border-2 transition-all ${
                      selectedVoteType === "sim"
                        ? "border-green-500 bg-green-50"
                        : "border-gray-200 hover:border-green-300 hover:bg-green-50/50"
                    }`}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <div
                        className={`w-12 h-12 rounded-full flex items-center justify-center ${
                          selectedVoteType === "sim"
                            ? "bg-green-500"
                            : "bg-green-100"
                        }`}
                      >
                        <svg
                          className="w-6 h-6 text-white"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <span className="text-sm font-semibold text-gray-900">
                        Sim
                      </span>
                    </div>
                  </button>

                  <button
                    onClick={() => setSelectedVoteType("nao")}
                    className={`p-4 rounded-lg border-2 transition-all ${
                      selectedVoteType === "nao"
                        ? "border-red-500 bg-red-50"
                        : "border-gray-200 hover:border-red-300 hover:bg-red-50/50"
                    }`}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <div
                        className={`w-12 h-12 rounded-full flex items-center justify-center ${
                          selectedVoteType === "nao"
                            ? "bg-red-500"
                            : "bg-red-100"
                        }`}
                      >
                        <svg
                          className="w-6 h-6 text-white"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <span className="text-sm font-semibold text-gray-900">
                        Não
                      </span>
                    </div>
                  </button>

                  <button
                    onClick={() => setSelectedVoteType("abstencao")}
                    className={`p-4 rounded-lg border-2 transition-all ${
                      selectedVoteType === "abstencao"
                        ? "border-amber-500 bg-amber-50"
                        : "border-gray-200 hover:border-amber-300 hover:bg-amber-50/50"
                    }`}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <div
                        className={`w-12 h-12 rounded-full flex items-center justify-center ${
                          selectedVoteType === "abstencao"
                            ? "bg-amber-500"
                            : "bg-amber-100"
                        }`}
                      >
                        <svg
                          className="w-6 h-6 text-white"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <span className="text-sm font-semibold text-gray-900">
                        Me Abstenho
                      </span>
                    </div>
                  </button>
                </div>
              </div>
            )}

            {/* Botão de Salvar */}
            {selectedParlamentarForVote && selectedVoteType && (
              <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                <Button
                  onClick={() => {
                    if (!savingVote) {
                      setOpenAddVoteModal(false);
                      setSelectedPautaForVote(null);
                      setSelectedParlamentarForVote(null);
                      setSelectedVoteType(null);
                      setSavingVote(false);
                    }
                  }}
                  variant="outlined"
                  disabled={savingVote}
                >
                  Cancelar
                </Button>
                <LoadingButton
                  loading={savingVote}
                  disabled={savingVote}
                  onClick={async () => {
                    if (
                      !selectedPautaForVote ||
                      !selectedParlamentarForVote ||
                      !selectedVoteType
                    ) {
                      toast.error(
                        "Por favor, selecione todos os campos necessários."
                      );
                      return;
                    }

                    setSavingVote(true);

                    try {
                      const db = getFirestore();
                      const documentoRef = doc(
                        db,
                        "users",
                        "belacruz@eleg",
                        "pautas",
                        selectedPautaForVote.idPauta
                      );

                      const docSnapshot = await getDoc(documentoRef);

                      if (!docSnapshot.exists()) {
                        toast.error("Pauta não encontrada!");
                        setSavingVote(false);
                        return;
                      }

                      const documentData = docSnapshot.data();

                      // Criar o objeto de voto
                      const novoVoto: ParlamentarVoto = {
                        id: selectedParlamentarForVote.id,
                        parlamentar: selectedParlamentarForVote.id,
                        nome:
                          selectedParlamentarForVote.nome ||
                          selectedParlamentarForVote.parlamentarNome ||
                          "Nome não informado",
                        aprovacao: selectedVoteType,
                      };

                      // Primeiro, remover o voto existente se houver (para evitar duplicatas)
                      let dataWithoutVote = removeVoteFromCorrectArray(
                        documentData as any,
                        selectedParlamentarForVote.id
                      );

                      // Depois, adicionar o novo voto
                      const updatedData = addVoteToCorrectArray(
                        dataWithoutVote,
                        novoVoto
                      );

                      // Montar payload apenas com campos definidos
                      const updatePayload: any = {};

                      if (updatedData.opcoesVotacao !== undefined) {
                        updatePayload.opcoesVotacao = updatedData.opcoesVotacao;
                      }
                      if (updatedData.statusAtual !== undefined) {
                        updatePayload.statusAtual = updatedData.statusAtual;
                      }
                      if (updatedData.votos !== undefined) {
                        updatePayload.votos = updatedData.votos;
                      }
                      if (updatedData.votos1turno !== undefined) {
                        updatePayload.votos1turno = updatedData.votos1turno;
                      }
                      if (updatedData.votos2turno !== undefined) {
                        updatePayload.votos2turno = updatedData.votos2turno;
                      }

                      // Atualizar o documento (sem enviar valores undefined)
                      await updateDoc(documentoRef, updatePayload);

                      toast.success("Voto adicionado com sucesso!");

                      setSavingVote(false);
                      setOpenAddVoteModal(false);
                      setSelectedPautaForVote(null);
                      setSelectedParlamentarForVote(null);
                      setSelectedVoteType(null);
                    } catch (error: any) {
                      console.error("Erro ao adicionar voto:", error);
                      toast.error(
                        error?.message ||
                          "Erro ao adicionar voto. Tente novamente."
                      );
                      setSavingVote(false);
                    }
                  }}
                  variant="contained"
                  className="!bg-[#2970FF] hover:!bg-[#2970FF]/90"
                >
                  Salvar Voto
                </LoadingButton>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal para gerenciar votos da Ata */}
      <Dialog
        open={openAtaVotesModal}
        onClose={() => {
          if (!savingAtaVote) {
            setOpenAtaVotesModal(false);
            setSelectedAtaForVotes(null);
            setSelectedParlamentarForAtaVote(null);
            setSelectedAtaVoteType(null);
            setSavingAtaVote(false);
          }
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogContent className="!p-0">
          <div className="bg-gradient-to-r from-[#2970FF] to-[#2970FF]/90 px-6 py-4">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-xl font-bold text-white">
                  Gerenciar votos da Ata
                </h2>
                {selectedAtaForVotes && (
                  <p className="text-sm text-white/80 mt-1">
                    Ata:{" "}
                    {selectedAtaForVotes.tituloAtaExpediente || "Não informado"}
                  </p>
                )}
              </div>
              <IconButton
                onClick={() => {
                  if (!savingAtaVote) {
                    setOpenAtaVotesModal(false);
                    setSelectedAtaForVotes(null);
                    setSelectedParlamentarForAtaVote(null);
                    setSelectedAtaVoteType(null);
                    setSavingAtaVote(false);
                  }
                }}
                disabled={savingAtaVote}
                className="!text-white hover:!bg-white/20"
              >
                <XIcon />
              </IconButton>
            </div>
          </div>

          <div className="p-6 space-y-6 max-h-[70vh] overflow-y-auto">
            {/* Lista de votos existentes */}
            <div>
              <div className="flex items-center justify-between mb-3">
                <label className="block text-sm font-semibold text-gray-700">
                  Votos registrados
                </label>
                <span className="text-xs text-gray-500">
                  {ataVotes.length} voto(s)
                </span>
              </div>
              {ataVotes.length === 0 ? (
                <div className="border border-gray-200 rounded-lg p-6 text-center bg-gray-50">
                  <p className="text-sm font-medium text-gray-900">
                    Nenhum voto registrado para esta ata.
                  </p>
                  <p className="mt-1 text-xs text-gray-500">
                    Use a seção abaixo para registrar votos manualmente.
                  </p>
                </div>
              ) : (
                <div className="border border-gray-200 rounded-lg divide-y divide-gray-100">
                  {ataVotes.map((voto: any, index: number) => (
                    <div
                      key={voto.id || index}
                      className="px-4 py-3 flex items-center justify-between gap-3 hover:bg-gray-50 transition-colors"
                    >
                      <div className="flex items-center gap-3 flex-1">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-[#2970FF]/10 to-[#2970FF]/5 flex items-center justify-center text-xs font-semibold text-[#2970FF]">
                          {index + 1}
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900">
                            {voto.nome || "Nome não informado"}
                          </p>
                          <p className="text-xs text-gray-500">
                            {voto.aprovacao === "sim"
                              ? "Votou SIM"
                              : voto.aprovacao === "nao"
                              ? "Votou NÃO"
                              : "Se absteve"}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <span
                          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold border ${
                            voto.aprovacao === "sim"
                              ? "border-green-500 text-green-700 bg-green-50"
                              : voto.aprovacao === "nao"
                              ? "border-red-500 text-red-700 bg-red-50"
                              : "border-amber-500 text-amber-700 bg-amber-50"
                          }`}
                        >
                          {voto.aprovacao === "sim"
                            ? "Sim"
                            : voto.aprovacao === "nao"
                            ? "Não"
                            : "Me abstenho"}
                        </span>
                        <button
                          className="text-xs font-medium text-[#2970FF] hover:underline"
                          onClick={() => {
                            setSelectedParlamentarForAtaVote({
                              id: voto.id,
                              nome: voto.nome,
                            });
                            const tipo =
                              voto.aprovacao === "sim" ||
                              voto.aprovacao === "nao" ||
                              voto.aprovacao === "abster"
                                ? (voto.aprovacao as "sim" | "nao" | "abster")
                                : "abster";
                            setSelectedAtaVoteType(tipo);
                          }}
                        >
                          Editar
                        </button>
                        <button
                          className="text-xs font-medium text-red-600 hover:underline"
                          onClick={async () => {
                            if (!selectedAtaForVotes || !roomId) return;
                            try {
                              const db = getFirestore();
                              const votoRef = doc(
                                db,
                                "users",
                                "belacruz@eleg",
                                "sessoes",
                                `${roomId}`,
                                "atas",
                                `${selectedAtaForVotes.id}`,
                                "ataVotacao",
                                voto.id
                              );
                              await deleteDoc(votoRef);
                              toast.success("Voto removido com sucesso!");
                            } catch (error: any) {
                              console.error(
                                "Erro ao remover voto da ata:",
                                error
                              );
                              toast.error(
                                error?.message ||
                                  "Erro ao remover voto. Tente novamente."
                              );
                            }
                          }}
                        >
                          Remover
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Seleção de vereador para voto manual */}
            {(() => {
              // IDs que já votaram na ata
              const idsQueVotaram = new Set(
                ataVotes.map((v: any) => v.id as string)
              );

              const vereadoresNaoVotaram = parlamentares.filter(
                (parlamentar: any) => !idsQueVotaram.has(parlamentar.id)
              );

              return (
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <label className="block text-sm font-semibold text-gray-700">
                      Selecione o Vereador
                    </label>
                    <span className="text-xs text-gray-500">
                      {vereadoresNaoVotaram.length} vereador(es) disponível(is)
                    </span>
                  </div>
                  <div className="border border-gray-200 rounded-lg divide-y divide-gray-200 max-h-48 overflow-y-auto">
                    {parlamentares.map((parlamentar: any) => {
                      const isSelected =
                        selectedParlamentarForAtaVote?.id === parlamentar.id;
                      const jaVotou = idsQueVotaram.has(parlamentar.id);
                      return (
                        <button
                          key={parlamentar.id}
                          onClick={() =>
                            setSelectedParlamentarForAtaVote(parlamentar)
                          }
                          className={`w-full px-4 py-3 text-left flex items-center justify-between ${
                            isSelected
                              ? "bg-[#2970FF]/5 border-l-4 border-[#2970FF]"
                              : "hover:bg-gray-50"
                          } ${jaVotou ? "opacity-70" : ""}`}
                        >
                          <span className="text-sm font-medium text-gray-900">
                            {parlamentar.nome ||
                              parlamentar.parlamentarNome ||
                              "Nome não informado"}
                          </span>
                          <div className="flex items-center gap-2">
                            {jaVotou && (
                              <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 border border-gray-200">
                                Já votou
                              </span>
                            )}
                            {isSelected && (
                              <svg
                                className="w-4 h-4 text-[#2970FF]"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )}
                          </div>
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

            {/* Seleção do tipo de voto */}
            {selectedParlamentarForAtaVote && (
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-3">
                  Selecione o Voto
                </label>
                <div className="grid grid-cols-3 gap-3">
                  <button
                    onClick={() => setSelectedAtaVoteType("sim")}
                    className={`p-4 rounded-lg border-2 transition-all ${
                      selectedAtaVoteType === "sim"
                        ? "border-green-500 bg-green-50"
                        : "border-gray-200 hover:border-green-300 hover:bg-green-50/50"
                    }`}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <div
                        className={`w-12 h-12 rounded-full flex items-center justify-center ${
                          selectedAtaVoteType === "sim"
                            ? "bg-green-500"
                            : "bg-green-100"
                        }`}
                      >
                        <span className="text-white font-bold text-lg">✓</span>
                      </div>
                      <span className="text-sm font-semibold text-gray-900">
                        Sim
                      </span>
                    </div>
                  </button>

                  <button
                    onClick={() => setSelectedAtaVoteType("nao")}
                    className={`p-4 rounded-lg border-2 transition-all ${
                      selectedAtaVoteType === "nao"
                        ? "border-red-500 bg-red-50"
                        : "border-gray-200 hover:border-red-300 hover:bg-red-50/50"
                    }`}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <div
                        className={`w-12 h-12 rounded-full flex items-center justify-center ${
                          selectedAtaVoteType === "nao"
                            ? "bg-red-500"
                            : "bg-red-100"
                        }`}
                      >
                        <span className="text-white font-bold text-lg">✕</span>
                      </div>
                      <span className="text-sm font-semibold text-gray-900">
                        Não
                      </span>
                    </div>
                  </button>

                  <button
                    onClick={() => setSelectedAtaVoteType("abster")}
                    className={`p-4 rounded-lg border-2 transition-all ${
                      selectedAtaVoteType === "abster"
                        ? "border-amber-500 bg-amber-50"
                        : "border-gray-200 hover:border-amber-300 hover:bg-amber-50/50"
                    }`}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <div
                        className={`w-12 h-12 rounded-full flex items-center justify-center ${
                          selectedAtaVoteType === "abster"
                            ? "bg-amber-500"
                            : "bg-amber-100"
                        }`}
                      >
                        <span className="text-white font-bold text-lg">•</span>
                      </div>
                      <span className="text-sm font-semibold text-gray-900">
                        Me abstenho
                      </span>
                    </div>
                  </button>
                </div>
              </div>
            )}

            {/* Botões de ação */}
            {selectedParlamentarForAtaVote && selectedAtaVoteType && (
              <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                <Button
                  onClick={() => {
                    if (!savingAtaVote) {
                      setSelectedParlamentarForAtaVote(null);
                      setSelectedAtaVoteType(null);
                    }
                  }}
                  variant="outlined"
                  disabled={savingAtaVote}
                >
                  Limpar seleção
                </Button>
                <LoadingButton
                  loading={savingAtaVote}
                  disabled={savingAtaVote}
                  onClick={async () => {
                    if (
                      !selectedAtaForVotes ||
                      !selectedParlamentarForAtaVote ||
                      !selectedAtaVoteType
                    ) {
                      toast.error(
                        "Por favor, selecione o vereador e o tipo de voto."
                      );
                      return;
                    }

                    try {
                      setSavingAtaVote(true);

                      const db = getFirestore();
                      const votoRef = doc(
                        db,
                        "users",
                        "belacruz@eleg",
                        "sessoes",
                        `${roomId}`,
                        "atas",
                        `${selectedAtaForVotes.id}`,
                        "ataVotacao",
                        selectedParlamentarForAtaVote.id
                      );

                      await setDoc(
                        votoRef,
                        {
                          id: selectedParlamentarForAtaVote.id,
                          nome:
                            selectedParlamentarForAtaVote.nome ||
                            selectedParlamentarForAtaVote.parlamentarNome ||
                            "Nome não informado",
                          aprovacao: selectedAtaVoteType,
                        },
                        { merge: true }
                      );

                      toast.success("Voto da ata salvo com sucesso!");

                      setSavingAtaVote(false);
                      setSelectedParlamentarForAtaVote(null);
                      setSelectedAtaVoteType(null);
                    } catch (error: any) {
                      console.error("Erro ao salvar voto da ata:", error);
                      toast.error(
                        error?.message ||
                          "Erro ao salvar voto da ata. Tente novamente."
                      );
                      setSavingAtaVote(false);
                    }
                  }}
                  variant="contained"
                  className="!bg-[#2970FF] hover:!bg-[#2970FF]/90"
                >
                  Salvar voto da ata
                </LoadingButton>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal para marcar presença manualmente */}
      <Dialog
        open={openPresencaModal}
        onClose={() => {
          setOpenPresencaModal(false);
          setSelectedParlamentarForPresenca(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogContent className="!p-0">
          <div className="bg-gradient-to-r from-[#2970FF] to-[#2970FF]/90 px-6 py-4">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-bold text-white">
                Marcar Presença Manualmente
              </h2>
              <IconButton
                onClick={() => {
                  setOpenPresencaModal(false);
                  setSelectedParlamentarForPresenca(null);
                }}
                className="!text-white hover:!bg-white/20"
              >
                <XIcon />
              </IconButton>
            </div>
            <p className="text-sm text-white/80 mt-2">
              Selecione um vereador para marcar presença na sessão
            </p>
          </div>

          <div className="p-6 space-y-6 max-h-[70vh] overflow-y-auto">
            {/* Seleção de Vereador */}
            {(() => {
              // Criar um Set com os IDs dos vereadores que já marcaram presença
              const vereadoresComPresenca = new Set(
                presencaParlamentares.map((presenca: any) => presenca.id)
              );

              // Filtrar apenas vereadores que ainda não marcaram presença
              const vereadoresSemPresenca = parlamentares.filter(
                (parlamentar: any) => !vereadoresComPresenca.has(parlamentar.id)
              );

              return (
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <label className="block text-sm font-semibold text-gray-700">
                      Selecione o Vereador
                    </label>
                    <span className="text-xs text-gray-500">
                      {vereadoresSemPresenca.length} vereador(es) disponível(is)
                    </span>
                  </div>
                  {vereadoresSemPresenca.length === 0 ? (
                    <div className="border border-gray-200 rounded-lg p-8 text-center bg-gray-50">
                      <svg
                        className="mx-auto h-12 w-12 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                        />
                      </svg>
                      <p className="mt-2 text-sm font-medium text-gray-900">
                        Todos os vereadores já marcaram presença
                      </p>
                      <p className="mt-1 text-xs text-gray-500">
                        Não há vereadores disponíveis para marcar presença
                        manualmente.
                      </p>
                    </div>
                  ) : (
                    <div className="border border-gray-200 rounded-lg divide-y divide-gray-200 max-h-60 overflow-y-auto">
                      {vereadoresSemPresenca.map((parlamentar: any) => {
                        const isSelected =
                          selectedParlamentarForPresenca?.id === parlamentar.id;
                        return (
                          <button
                            key={parlamentar.id}
                            onClick={() =>
                              setSelectedParlamentarForPresenca(parlamentar)
                            }
                            className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors ${
                              isSelected
                                ? "bg-[#2970FF]/5 border-l-4 border-[#2970FF]"
                                : ""
                            }`}
                          >
                            <div className="flex items-center justify-between">
                              <span className="text-sm font-medium text-gray-900">
                                {parlamentar.nome ||
                                  parlamentar.parlamentarNome ||
                                  "Nome não informado"}
                              </span>
                              {isSelected && (
                                <svg
                                  className="w-5 h-5 text-[#2970FF]"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              )}
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })()}

            {/* Botão de Salvar */}
            {selectedParlamentarForPresenca && (
              <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                <Button
                  onClick={() => {
                    setOpenPresencaModal(false);
                    setSelectedParlamentarForPresenca(null);
                  }}
                  variant="outlined"
                >
                  Cancelar
                </Button>
                <LoadingButton
                  onClick={async () => {
                    if (!selectedParlamentarForPresenca) {
                      return;
                    }

                    try {
                      const db = getFirestore();
                      const documentoRef = doc(
                        db,
                        "users",
                        "belacruz@eleg",
                        "sessoes",
                        `${roomId}`,
                        "presencaParlamentares",
                        selectedParlamentarForPresenca.id
                      );

                      // Verificar se o documento já existe
                      const docSnapshot = await getDoc(documentoRef);

                      if (docSnapshot.exists()) {
                        // Se existe, atualizar
                        await updateDoc(documentoRef, {
                          presenca: true,
                          nome:
                            selectedParlamentarForPresenca.nome ||
                            selectedParlamentarForPresenca.parlamentarNome ||
                            "Nome não informado",
                          ...selectedParlamentarForPresenca,
                        });
                      } else {
                        // Se não existe, criar
                        await setDoc(documentoRef, {
                          presenca: true,
                          nome:
                            selectedParlamentarForPresenca.nome ||
                            selectedParlamentarForPresenca.parlamentarNome ||
                            "Nome não informado",
                          ...selectedParlamentarForPresenca,
                        });
                      }

                      toast.success("Presença marcada com sucesso!");

                      setOpenPresencaModal(false);
                      setSelectedParlamentarForPresenca(null);
                    } catch (error: any) {
                      console.error("Erro ao marcar presença:", error);
                      toast.error("Erro ao marcar presença. Tente novamente.");
                    }
                  }}
                  variant="contained"
                  className="!bg-[#2970FF] hover:!bg-[#2970FF]/90"
                >
                  Marcar Presença
                </LoadingButton>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal de ações da pauta */}
      <Dialog
        open={openPautaActionsModal}
        onClose={() => {
          setOpenPautaActionsModal(false);
          setSelectedPautaForActions(null);
        }}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent className="!p-0">
          {selectedPautaForActions && (
            <>
              <div className="bg-gradient-to-r from-[#2970FF] to-[#2970FF]/90 px-6 py-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-xl font-bold text-white">
                      Ações da Pauta
                    </h2>
                    <p className="text-sm text-white/80 mt-1">
                      Pauta Nº {selectedPautaForActions.numero || "N/A"}
                    </p>
                  </div>
                  <IconButton
                    onClick={() => {
                      setOpenPautaActionsModal(false);
                      setSelectedPautaForActions(null);
                    }}
                    className="!text-white hover:!bg-white/20"
                  >
                    <XIcon />
                  </IconButton>
                </div>
              </div>

              <div className="p-6 space-y-4">
                {/* Botão Exibir/Retirar do telão */}
                <Button
                  fullWidth
                  variant="contained"
                  startIcon={
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  }
                  onClick={async () => {
                    const db = getFirestore();
                    const item = selectedPautaForActions;
                    const novoDocumentoRef = doc(
                      collection(db, "users"),
                      "belacruz@eleg"
                    );
                    const subcolecaoRef = collection(
                      novoDocumentoRef,
                      "sessoes"
                    );
                    const novoDocumento2Ref = doc(subcolecaoRef, `${roomId}`);
                    const subcolecaoRefAtas = collection(
                      novoDocumento2Ref,
                      "pautas"
                    );
                    const novoDocumento2RefAtas = doc(
                      subcolecaoRefAtas,
                      item.id
                    );

                    const documentoRef = doc(
                      db,
                      "users",
                      "belacruz@eleg",
                      "pautas",
                      item.idPauta
                    );

                    const docSnapshot = await getDoc(documentoRef);
                    if (docSnapshot.exists()) {
                      const documentData = docSnapshot.data();
                      if (item.opcoesVotacao === "2-turnos") {
                        const initializedData =
                            initializeVotingArrays(documentData);
                          const votos1turnoCount = Array.isArray(
                            initializedData.votos1turno
                          )
                            ? initializedData.votos1turno.length
                            : 0;
                          const votos2turnoCount = Array.isArray(
                            initializedData.votos2turno
                          )
                            ? initializedData.votos2turno.length
                            : 0;
                          const aguardandoSegundoTurno =
                            (initializedData.statusAtual === "votado" ||
                              initializedData.statusAtual === "finalizada") &&
                            votos1turnoCount > 0 &&
                            votos2turnoCount === 0;

                          if (
                            initializedData.statusAtual === "leitura" ||
                            initializedData.statusAtual === "aguardo" ||
                            !initializedData.statusAtual
                          ) {
                            await updateDoc(documentoRef, {
                              ...initializedData,
                              statusAtual: "votacao1turno",
                              encerrarVotacao: deleteField(),
                            });
                        } else if (
                          initializedData.statusAtual === "votacao1turno"
                        ) {
                            if (canProceedToNextTurn(initializedData)) {
                              await updateDoc(documentoRef, {
                                ...initializedData,
                                statusAtual: "votacao2turno",
                                encerrarVotacao: deleteField(),
                              });
                            }
                          } else if (aguardandoSegundoTurno) {
                            await updateDoc(documentoRef, {
                              ...initializedData,
                              statusAtual: "votacao2turno",
                              encerrarVotacao: deleteField(),
                            });
                          }
                        }

                      // Garante que apenas uma pauta fique ativa no telão/tablet.
                      // Também limpa flags antigas de encerramento para não tocar som indevido.
                      const pautasSessaoSnapshot = await getDocs(
                        subcolecaoRefAtas
                      );
                      const batch = writeBatch(db);

                      pautasSessaoSnapshot.docs.forEach((sessaoPautaDoc) => {
                        batch.update(sessaoPautaDoc.ref, {
                          votado: false,
                          iniciarVotacao: deleteField(),
                          encerrarVotacao: deleteField(),
                        });
                      });

                      if (item.votado == true) {
                        await batch.commit();
                        setSelectedPautaForActions((prev: any) =>
                          prev
                            ? {
                                ...prev,
                                votado: false,
                                iniciarVotacao: undefined,
                                encerrarVotacao: undefined,
                              }
                            : prev
                        );
                      } else {
                        const statusDoc = await getDoc(novoDocumento2Ref);
                        if (statusDoc.exists()) {
                          await updateDoc(novoDocumento2Ref, {
                            statusConfigSessao: 6,
                          });
                        }

                        batch.update(novoDocumento2RefAtas, {
                          votado: true,
                          iniciarVotacao: true,
                          encerrarVotacao: deleteField(),
                        });
                        await batch.commit();
                        setSelectedPautaForActions((prev: any) =>
                          prev
                            ? {
                                ...prev,
                                votado: true,
                                iniciarVotacao: true,
                                encerrarVotacao: undefined,
                              }
                            : prev
                        );
                      }

                      toast.success(
                        item.votado == true
                          ? "Pauta retirada do telão"
                          : "Pauta exibida para voto"
                      );
                    }
                  }}
                  className="!bg-[#2970FF] hover:!bg-[#2970FF]/90 !text-white"
                >
                  {(selectedPautaForActions as any).votado == true
                    ? "Retirar do telão"
                    : "Exibir para voto"}
                </Button>

                {/* Botão Finalizar votação */}
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  }
                  onClick={async () => {
                    const db = getFirestore();
                    const item = selectedPautaForActions;
                    const subcolecaoRefAtas = collection(
                      doc(collection(db, "users"), "belacruz@eleg"),
                      "sessoes"
                    );
                    const novoDocumento2RefAtas = doc(
                      collection(doc(subcolecaoRefAtas, `${roomId}`), "pautas"),
                      item.id
                    );

                    const documentoRef = doc(
                      db,
                      "users",
                      "belacruz@eleg",
                      "pautas",
                      item.idPauta
                    );

                    if (item.statusAtual == "votacao2turno") {
                      await updateDoc(documentoRef, {
                        encerrarVotacao: true,
                        statusAtual: "votado",
                        votada: true,
                      });
                    } else {
                      await updateDoc(documentoRef, {
                        encerrarVotacao: true,
                        statusAtual: "votado",
                        votada: true,
                      });
                    }

                    const ataSnapshot = await getDoc(novoDocumento2RefAtas);
                    if (ataSnapshot.exists()) {
                      await updateDoc(novoDocumento2RefAtas, {
                        encerrarVotacao: true,
                      });
                    }

                    toast.success("Votação finalizada com sucesso!");
                  }}
                  className="!border-[#2970FF] !text-[#2970FF] hover:!bg-[#2970FF]/10"
                >
                  Finalizar votação
                </Button>

                {/* Botão Marcar voto manualmente */}
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                  }
                  onClick={() => {
                    setOpenPautaActionsModal(false);
                    setSelectedPautaForVote(selectedPautaForActions);
                    setOpenAddVoteModal(true);
                  }}
                  className="!border-green-500 !text-green-600 hover:!bg-green-50"
                >
                  Marcar voto manualmente
                </Button>

                {/* Seção de Votos dos Vereadores */}
                {(() => {
                  // Obter os votos atuais da pauta (preferindo map em tempo real)
                  const currentVotes =
                    pautaVotesMap[selectedPautaForActions.idPauta]?.votes ||
                    getCurrentVotingArray(selectedPautaForActions as any);

                  // Mostrar seção se houver votos ou se a pauta estiver em votação
                  const shouldShowVotes =
                    currentVotes.length > 0 ||
                    selectedPautaForActions.votado == true ||
                    selectedPautaForActions.statusAtual === "votacao1turno" ||
                    selectedPautaForActions.statusAtual === "votacao2turno";

                  if (!shouldShowVotes) return null;

                  // Criar um mapa dos votos por ID do parlamentar
                  const votosMap = new Map();
                  currentVotes.forEach((voto: any) => {
                    votosMap.set(voto.parlamentar, voto);
                  });

                  // Separar vereadores que votaram e que não votaram
                  const vereadoresVotaram: any[] = [];
                  const vereadoresNaoVotaram: any[] = [];

                  parlamentares.forEach((parlamentar: any) => {
                    const voto = votosMap.get(parlamentar.id);
                    if (voto) {
                      vereadoresVotaram.push({
                        parlamentar,
                        voto,
                      });
                    } else {
                      vereadoresNaoVotaram.push(parlamentar);
                    }
                  });

                  // Função para obter o texto do voto
                  const getVotoText = (aprovacao: string) => {
                    switch (aprovacao) {
                      case "sim":
                        return "Sim";
                      case "nao":
                        return "Não";
                      case "abster":
                      case "abstencao":
                        return "Me Abstenho";
                      default:
                        return "Não informado";
                    }
                  };

                  // Função para obter as classes CSS do voto
                  const getVotoClasses = (aprovacao: string) => {
                    switch (aprovacao) {
                      case "sim":
                        return "bg-green-50 text-green-700 border-green-200";
                      case "nao":
                        return "bg-red-50 text-red-700 border-red-200";
                      case "abster":
                      case "abstencao":
                        return "bg-amber-50 text-amber-700 border-amber-200";
                      default:
                        return "bg-gray-50 text-gray-700 border-gray-200";
                    }
                  };

                  // Função para obter o ícone do voto
                  const getVotoIcon = (aprovacao: string) => {
                    switch (aprovacao) {
                      case "sim":
                        return (
                          <svg
                            className="w-4 h-4"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        );
                      case "nao":
                        return (
                          <svg
                            className="w-4 h-4"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        );
                      case "abster":
                      case "abstencao":
                        return (
                          <svg
                            className="w-4 h-4"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
                              clipRule="evenodd"
                            />
                          </svg>
                        );
                      default:
                        return null;
                    }
                  };

                  return (
                    <div className="mt-6 pt-6 border-t border-gray-200">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-sm font-semibold text-gray-700">
                          Votos dos Vereadores
                        </h3>
                        <Tooltip title="Adicionar voto manualmente">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setOpenPautaActionsModal(false);
                              setSelectedPautaForVote(selectedPautaForActions);
                              setOpenAddVoteModal(true);
                            }}
                            className="!bg-[#2970FF]/10 hover:!bg-[#2970FF]/20 !text-[#2970FF]"
                          >
                            <svg
                              className="w-5 h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 4v16m8-8H4"
                              />
                            </svg>
                          </IconButton>
                        </Tooltip>
                      </div>

                      <div className="space-y-4 max-h-[400px] overflow-y-auto">
                        {/* Vereadores que votaram */}
                        {vereadoresVotaram.length > 0 && (
                          <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                            <div className="bg-gradient-to-r from-[#2970FF] to-[#2970FF]/90 px-4 py-3 border-b border-[#2970FF]/20">
                              <div className="flex items-center justify-between">
                                <h4 className="text-sm font-semibold text-white">
                                  Votaram
                                </h4>
                                <span className="inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-white/20 text-white backdrop-blur-sm">
                                  {vereadoresVotaram.length}
                                </span>
                              </div>
                            </div>
                            <div className="divide-y divide-gray-100">
                              {vereadoresVotaram.map(
                                ({ parlamentar, voto }, index) => (
                                  <div
                                    key={parlamentar.id}
                                    className="px-4 py-3 hover:bg-gray-50 transition-colors duration-150"
                                  >
                                    <div className="flex items-center justify-between gap-3">
                                      <div className="flex items-center gap-3 flex-1">
                                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-[#2970FF]/10 to-[#2970FF]/5 flex items-center justify-center text-xs font-semibold text-[#2970FF]">
                                          {index + 1}
                                        </div>
                                        <span className="text-sm font-medium text-gray-900">
                                          {voto.nome ||
                                            parlamentar.nome ||
                                            parlamentar.parlamentarNome ||
                                            "Nome não informado"}
                                        </span>
                                      </div>

                                      <div className="flex items-center gap-2">
                                        <span
                                          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold border ${getVotoClasses(
                                            voto.aprovacao
                                          )}`}
                                        >
                                          {getVotoIcon(voto.aprovacao)}
                                          {getVotoText(voto.aprovacao)}
                                        </span>

                                        {/* Ações do administrador: editar / remover voto */}
                                        <button
                                          className="text-xs font-medium text-[#2970FF] hover:underline"
                                          onClick={() => {
                                            // Pré-carregar o modal de voto manual com este vereador e voto
                                            setSelectedPautaForVote(
                                              selectedPautaForActions
                                            );
                                            setSelectedParlamentarForVote(
                                              parlamentar
                                            );
                                            setSelectedVoteType(
                                              voto.aprovacao as
                                                | "sim"
                                                | "nao"
                                                | "abstencao"
                                            );
                                            setOpenAddVoteModal(true);
                                          }}
                                        >
                                          Editar
                                        </button>
                                        <button
                                          className="text-xs font-medium text-red-600 hover:underline"
                                          onClick={async () => {
                                            try {
                                              const db = getFirestore();
                                              const documentoRef = doc(
                                                db,
                                                "users",
                                                "belacruz@eleg",
                                                "pautas",
                                                selectedPautaForActions.idPauta
                                              );

                                              const docSnapshot = await getDoc(
                                                documentoRef
                                              );

                                              if (!docSnapshot.exists()) {
                                                toast.error(
                                                  "Pauta não encontrada!"
                                                );
                                                return;
                                              }

                                              const documentData =
                                                docSnapshot.data();

                                              // Remover o voto deste parlamentar
                                              const updatedData =
                                                removeVoteFromCorrectArray(
                                                  documentData as any,
                                                  parlamentar.id
                                                );

                                              // Montar payload apenas com campos definidos
                                              const updatePayload: any = {};

                                              if (
                                                updatedData.opcoesVotacao !==
                                                undefined
                                              ) {
                                                updatePayload.opcoesVotacao =
                                                  updatedData.opcoesVotacao;
                                              }
                                              if (
                                                updatedData.statusAtual !==
                                                undefined
                                              ) {
                                                updatePayload.statusAtual =
                                                  updatedData.statusAtual;
                                              }
                                              if (
                                                updatedData.votos !== undefined
                                              ) {
                                                updatePayload.votos =
                                                  updatedData.votos;
                                              }
                                              if (
                                                updatedData.votos1turno !==
                                                undefined
                                              ) {
                                                updatePayload.votos1turno =
                                                  updatedData.votos1turno;
                                              }
                                              if (
                                                updatedData.votos2turno !==
                                                undefined
                                              ) {
                                                updatePayload.votos2turno =
                                                  updatedData.votos2turno;
                                              }

                                              await updateDoc(
                                                documentoRef,
                                                updatePayload
                                              );

                                              toast.success(
                                                "Voto removido com sucesso!"
                                              );
                                            } catch (error: any) {
                                              console.error(
                                                "Erro ao remover voto:",
                                                error
                                              );
                                              toast.error(
                                                error?.message ||
                                                  "Erro ao remover voto. Tente novamente."
                                              );
                                            }
                                          }}
                                        >
                                          Remover
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}

                        {/* Vereadores que não votaram */}
                        {vereadoresNaoVotaram.length > 0 && (
                          <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
                            <div className="bg-gradient-to-r from-gray-400 to-gray-500 px-4 py-3 border-b border-gray-300">
                              <div className="flex items-center justify-between">
                                <h4 className="text-sm font-semibold text-white">
                                  Ainda não votaram
                                </h4>
                                <span className="inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-white/20 text-white backdrop-blur-sm">
                                  {vereadoresNaoVotaram.length}
                                </span>
                              </div>
                            </div>
                            <div className="divide-y divide-gray-200">
                              {vereadoresNaoVotaram.map(
                                (parlamentar: any, index) => (
                                  <div
                                    key={parlamentar.id}
                                    className="px-4 py-3 hover:bg-gray-100 transition-colors duration-150"
                                  >
                                    <div className="flex items-center justify-between">
                                      <div className="flex items-center gap-3 flex-1">
                                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-xs font-semibold text-gray-500">
                                          {index + 1}
                                        </div>
                                        <span className="text-sm font-medium text-gray-600">
                                          {parlamentar.nome ||
                                            parlamentar.parlamentarNome ||
                                            "Nome não informado"}
                                        </span>
                                      </div>
                                      <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border border-gray-300 bg-white text-gray-600">
                                        <svg
                                          className="w-4 h-4 text-gray-400"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                          />
                                        </svg>
                                        Aguardando voto
                                      </span>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}

                        {/* Mensagem se não houver vereadores */}
                        {vereadoresVotaram.length === 0 &&
                          vereadoresNaoVotaram.length === 0 && (
                            <div className="text-center py-8 px-4 bg-gray-50 rounded-lg border border-gray-200">
                              <svg
                                className="mx-auto h-12 w-12 text-gray-400"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                />
                              </svg>
                              <p className="mt-2 text-sm text-gray-500">
                                Nenhum vereador encontrado.
                              </p>
                            </div>
                          )}
                      </div>
                    </div>
                  );
                })()}

                {/* Informações da pauta */}
                <div className="mt-6 pt-6 border-t border-gray-200">
                  <h3 className="text-sm font-semibold text-gray-700 mb-3">
                    Informações da Pauta
                  </h3>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Autor:</span>
                      <span className="text-gray-900 font-medium">
                        {selectedPautaForActions.autor || "Não informado"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Tipo:</span>
                      <span className="text-gray-900 font-medium">
                        {simplesOptions.find(
                          (opcao) =>
                            opcao.value ===
                            selectedPautaForActions.pautaLegislativa
                        )?.label || "Não informado"}
                      </span>
                    </div>
                    {selectedPautaForActions.opcoesVotacao === "2-turnos" && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Status:</span>
                        <span className="text-gray-900 font-medium">
                          {getTwoTurnStatus(selectedPautaForActions) ===
                          "votacao1turno"
                            ? "1º Turno"
                            : getTwoTurnStatus(selectedPautaForActions) ===
                              "votacao2turno"
                            ? "2º Turno"
                            : getTwoTurnStatus(selectedPautaForActions) ===
                              "pendente2turno"
                            ? "2º turno pendente"
                            : "Finalizada"}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
